
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire34b5"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire34b5"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("l1i8p", function(module, exports) {
$parcel$export(module.exports, "BottomCallToAction", function () { return (parcelRequire("2Uedv")).BottomCallToAction; });
$parcel$export(module.exports, "CallToAction", function () { return (parcelRequire("5JoNJ")).CallToAction; });
$parcel$export(module.exports, "CustomerTestimonials", function () { return (parcelRequire("i1SI4")).CustomerTestimonials; });
$parcel$export(module.exports, "HeroCarousel", function () { return (parcelRequire("us1N6")).HeroCarousel; });
$parcel$export(module.exports, "Logos", function () { return (parcelRequire("behZZ")).Logos; });
$parcel$export(module.exports, "FeaturesHighlight", function () { return (parcelRequire("anFhN")).FeaturesHighlight; });
$parcel$export(module.exports, "Integration", function () { return (parcelRequire("ifNiy")).Integration; });
$parcel$export(module.exports, "IntegrationRefresh", function () { return (parcelRequire("3OVYv")).Integration; });
$parcel$export(module.exports, "MobileApp", function () { return (parcelRequire("euqle")).MobileApp; });
$parcel$export(module.exports, "SideNav", function () { return (parcelRequire("5f18E")).SideNav; });

var $2Uedv = parcelRequire("2Uedv");

var $5JoNJ = parcelRequire("5JoNJ");

var $fsuqf = parcelRequire("fsuqf");

var $i1SI4 = parcelRequire("i1SI4");

var $anFhN = parcelRequire("anFhN");

var $8J2ZV = parcelRequire("8J2ZV");

var $us1N6 = parcelRequire("us1N6");

var $ifNiy = parcelRequire("ifNiy");

var $3OVYv = parcelRequire("3OVYv");

var $behZZ = parcelRequire("behZZ");

var $euqle = parcelRequire("euqle");

var $5f18E = parcelRequire("5f18E");

var $4Fnxt = parcelRequire("4Fnxt");
parcelRequire("5uGt2");
var $7kpd6 = parcelRequire("7kpd6");

});
parcelRegister("2Uedv", function(module, exports) {
$parcel$export(module.exports, "BottomCallToAction", function () { return $c3e386a025d6cfc5$export$c9eb72e23dbe5cf6; });
/* bottom-call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $c3e386a025d6cfc5$var$containerStyles = null;
const $c3e386a025d6cfc5$var$innerContainerStyles = null;
const $c3e386a025d6cfc5$var$buttonContainerStyles = null;
const $c3e386a025d6cfc5$export$c9eb72e23dbe5cf6 = ({ title: title, emphasisColor: emphasisColor, body: body, button: button })=>{
    const emphasisStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1stzn7od _1c1jn7od _bfhk1hlo _1rjcxncg _cg41cd5j _haj1cd5j _811zcd5j _125xcd5j _1afj1h6o _10so1h6o _14iu1h6o _31ku1h6o _1n46idpf _122gidpf _efi8idpf _clfdidpf _if5yidpf _1phwidpf _17o1idpf _11pqidpf _1gnpidpf _1bygidpf _1ql6idpf _q0a5idpf _7e5bidpf _o7a8idpf _5h4jidpf _c3k8idpf"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "8",
            children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _2lx21bp4 _4cvr1h6o _zulputpp _16imxncg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                        className: (0, $2jatx.default)([
                            emphasisColor && "_r7o3eibj _cq6tn7od",
                            "h1-xl"
                        ]),
                        style: {
                            "--_1qfmyyb": (0, $6ZVlx.default)(emphasisColor)
                        },
                        children: title
                    }),
                    body ? body : null,
                    button && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1q51xy5q"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                            href: button.buttonHref,
                            responsiveSize: {
                                mobile: "small",
                                tablet: "large",
                                desktop: "xlarge",
                                xl_desktop: "xlarge"
                            },
                            children: button.buttonLabel
                        })
                    })
                ]
            })
        })
    });
};

});

parcelRegister("5JoNJ", function(module, exports) {
$parcel$export(module.exports, "CallToAction", function () { return $fb865668dbde9df8$export$9438b36140854db6; });
/* call-to-action.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $kbpa7 = parcelRequire("kbpa7");
const $fb865668dbde9df8$var$callToActionStyles = null;
const $fb865668dbde9df8$var$typographyOverrides = null;
const $fb865668dbde9df8$var$polygonStyles = null;
const $fb865668dbde9df8$var$contentStyles = null;
const $fb865668dbde9df8$export$9438b36140854db6 = ({ header: header, paragraph: paragraph, button: button, backgroundColor: backgroundColor = "black" })=>{
    const buttonProps = backgroundColor === "blue" ? {
        variant: "primary_alt",
        colorAgainst: "other"
    } : {
        variant: "primary",
        colorAgainst: "black"
    };
    const transformedButton = /*#__PURE__*/ (0, $1oC0p.cloneElement)(button, buttonProps);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        className: (0, $2jatx.default)([
            "_p12f1git _195g1wug _y3gn1h6o"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            style: {
                "--background-color": (0, $kbpa7.wacToken)(`color.primary.${backgroundColor}`)
            },
            className: (0, $2jatx.default)([
                "_11q76ulk _mkrz1q5k _1vthpg2b _1yt4koci"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "8",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c11p5 _zulpu2gc _6rthxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    "h3"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: header
                            }),
                            paragraph && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    "_1mou78py",
                                    ".body-md"
                                ]),
                                style: {
                                    color: (0, $kbpa7.wacToken)("color.neutral.light0")
                                },
                                children: paragraph
                            })
                        ]
                    })
                }),
                transformedButton
            ]
        })
    });
};

});

parcelRegister("fsuqf", function(module, exports) {
$parcel$export(module.exports, "Connector", function () { return $0d5223a79dc9016a$export$b2278035370d6017; });
/* connector.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $gIKKj = parcelRequire("gIKKj");

var $areUn = parcelRequire("areUn");

var $32ng3 = parcelRequire("32ng3");

var $kdSM2 = parcelRequire("kdSM2");

var $jiDxV = parcelRequire("jiDxV");
const $0d5223a79dc9016a$export$b2278035370d6017 = ({ title: title, text: text, linkText: linkText, linkHref: linkHref, linkDataEventProps: linkDataEventProps, customerQuotes: customerQuotes, mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const isWACRefreshGateEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacRefreshTeam26Gate);
    const checkWacRefreshExperiment = (0, $gIKKj.useExperiment)((0, $areUn.wacRefreshQ4Fy26Experiment));
    const isWacRefresh = isWACRefreshGateEnabled || checkWacRefreshExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && checkWacRefreshExperiment.value;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1rjc1epz _bfhk1hlo _1e0c1txw _2lx21bp4 _zulpoahv",
            isWacRefresh && "_bfhk1rga _1rjc16xz _zulp16xz _1t2pys9h _2osnys9h _133i1wqb _81641wqb"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    isWacRefresh && "_4jtahkll"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $kbpa7.ColumnLayout), {
                    layout: "5-7",
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_cg41cd5j _125xcd5j _xsmr1h6o",
                                isWacRefresh && "_cg411hlo _125x1hlo _xsmr1e5h",
                                "contentBlock"
                            ]),
                            style: {
                                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                            },
                            children: [
                                /*#__PURE__*/ (0, $7VQPk.jsx)("h2", {
                                    className: (0, $2jatx.default)([
                                        "_1pfhxy5q _6rthu2gc _476didpf",
                                        isWacRefresh && "_1pfhidpf _6rthidpf"
                                    ]),
                                    children: title
                                }),
                                /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                    className: (0, $2jatx.default)([
                                        "_1mouidpf",
                                        isWacRefresh && "_1pfhutpp"
                                    ]),
                                    children: text
                                }),
                                linkText && linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1pfh1ejb _6rthxy5q _srwz1ejb"
                                    ]),
                                    children: isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Button), {
                                        href: linkHref,
                                        variant: "secondary",
                                        colorAgainst: "white",
                                        responsiveSize: {
                                            mobile: "small",
                                            tablet: "small",
                                            desktop: "large",
                                            xl_desktop: "large"
                                        },
                                        dataEventProps: linkDataEventProps,
                                        children: linkText
                                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                        "aria-label": linkText,
                                        text: linkText,
                                        href: linkHref,
                                        type: "primary",
                                        bgColor: "bgBlackBlue",
                                        ...linkDataEventProps && {
                                            dataEventProps: linkDataEventProps
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kdSM2.CustomerQuoteCarousel), {
                            customerQuotes: customerQuotes
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jiDxV.LogosMarquee), {
                mobileLogos: mobileLogos,
                tabletLogos: tabletLogos,
                desktopLogos: desktopLogos
            })
        ]
    });
};
var $0d5223a79dc9016a$export$2e2bcd8739ae039 = $0d5223a79dc9016a$export$b2278035370d6017;
const $0d5223a79dc9016a$var$containerCss = null;
const $0d5223a79dc9016a$var$refreshContainerCss = null;
const $0d5223a79dc9016a$var$lightTextCss = null;
const $0d5223a79dc9016a$var$refreshTextBlockCss = null;
const $0d5223a79dc9016a$var$titleCss = null;
const $0d5223a79dc9016a$var$refreshTitleCss = null;
const $0d5223a79dc9016a$var$textCss = null;
const $0d5223a79dc9016a$var$refreshBodyTextCss = null;
const $0d5223a79dc9016a$var$refreshColumnOverrideCss = null;
const $0d5223a79dc9016a$var$linkCss = null;

});
parcelRegister("kdSM2", function(module, exports) {
$parcel$export(module.exports, "CustomerQuoteCarousel", function () { return $6e4e4b8ac7dd4aed$export$abab76d12bbd8406; });
/* customer-quote-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $7IesZ = parcelRequire("7IesZ");

var $9BG80 = parcelRequire("9BG80");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $gIKKj = parcelRequire("gIKKj");

var $areUn = parcelRequire("areUn");

var $32ng3 = parcelRequire("32ng3");
const $6e4e4b8ac7dd4aed$var$messages = {
    previousSlide: {
        id: "customer-quote-carousel.previous-slide",
        defaultMessage: "Previous slide"
    },
    nextSlide: {
        id: "customer-quote-carousel.next-slide",
        defaultMessage: "Next slide"
    }
};
const $6e4e4b8ac7dd4aed$export$abab76d12bbd8406 = ({ customerQuotes: customerQuotes })=>{
    const isWACRefreshGateEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacRefreshTeam26Gate);
    const checkWacRefreshExperiment = (0, $gIKKj.useExperiment)((0, $areUn.wacRefreshQ4Fy26Experiment));
    const isWacRefresh = isWACRefreshGateEnabled || checkWacRefreshExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && checkWacRefreshExperiment.value;
    const [activeQuoteIndex, setActiveQuoteIndex] = (0, $1oC0p.useState)(0);
    const prevSlide = ()=>{
        if (activeQuoteIndex > 0) setActiveQuoteIndex(activeQuoteIndex - 1);
    };
    const nextSlide = ()=>{
        if (activeQuoteIndex < customerQuotes.length - 1) setActiveQuoteIndex(activeQuoteIndex + 1);
    };
    const intl = (0, $8e22h.default)();
    const logoSection = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: customerQuotes.map(({ companyLogo: companyLogo }, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": index !== activeQuoteIndex,
                className: (0, $2jatx.default)([
                    "_nd5lgbua _3um015tv _1bsb11ux _4t3i1ylp"
                ]),
                style: {
                    "--_neqv2r": (0, $6ZVlx.default)(index === activeQuoteIndex ? "visible" : "hidden")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    // @ts-ignore
                    src: companyLogo[0].src,
                    // @ts-ignore
                    alt: companyLogo[0].alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain",
                        objectPosition: "left"
                    }
                })
            }, index))
    });
    const quoteSection = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9",
            "_tfwpidpf"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.PullQuote), {
            // @ts-ignore
            quote: customerQuotes[activeQuoteIndex].quote,
            authorName: // @ts-ignore
            customerQuotes[activeQuoteIndex].advocateName,
            authorDetails: // @ts-ignore
            customerQuotes[activeQuoteIndex].advocateJobTitle
        })
    });
    const legacyNavigationButtons = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _4cvr1h6o _zulputpp"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                onClick: prevSlide,
                disabled: activeQuoteIndex === 0,
                "aria-label": intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.previousSlide),
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                ]),
                style: {
                    "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                    ]),
                    style: {
                        "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                        "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7IesZ))), {
                        label: intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.previousSlide)
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_1bsb183y _1mouidpf"
                ]),
                style: {
                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                },
                children: `${activeQuoteIndex + 1}/${customerQuotes.length}`
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                onClick: nextSlide,
                disabled: activeQuoteIndex === customerQuotes.length - 1,
                "aria-label": intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.nextSlide),
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke _1x1a73ad _v42d73ad _1tc8pmk4 _64781yg0"
                ]),
                style: {
                    "--_1ljptrt": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light1000")),
                    "--_4cxk3s": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light800"))
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3"
                    ]),
                    style: {
                        "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                        "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500"))
                    },
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($9BG80))), {
                        label: intl.formatMessage($6e4e4b8ac7dd4aed$var$messages.nextSlide)
                    })
                })
            })
        ]
    });
    if (isWacRefresh) return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_2rkogktf _bfhkcd5j _1yt4oahv _15tx1ejb",
                    "_cg41r2ho _125xr2ho _1tjqr2ho",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _2lx21bp4 _zulp1ejb _9959vrvc _a64koahv"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb11ux _1y9l1fhb"
                                ]),
                                children: logoSection
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf"
                                ]),
                                children: quoteSection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bahesu3"
                        ]),
                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.GalleryControls), {
                            showCounter: true,
                            currentCount: activeQuoteIndex + 1,
                            totalCount: customerQuotes.length,
                            onPrevious: ()=>setActiveQuoteIndex(activeQuoteIndex - 1),
                            onNext: ()=>setActiveQuoteIndex(activeQuoteIndex + 1),
                            size: "small"
                        })
                    })
                ]
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _4t3i1ns9"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                "aria-hidden": true,
                className: (0, $2jatx.default)([
                    "_nd5lgbua",
                    "_1yt4xy5q _15tx1ejb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c11p5 _4t3i1ns9",
                        "_1q5188uy"
                    ]),
                    children: customerQuotes.map((customerQuote, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_nd5lgbua",
                                "_3um015vq",
                                "_tfwpidpf"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.PullQuote), {
                                quote: customerQuote.quote,
                                authorName: customerQuote.advocateName,
                                authorDetails: customerQuote.advocateJobTitle
                            })
                        }, index))
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_2rkovwyg _bfhk1nc2 _1yt4xy5q _4t3i1ns9 _1e0c1txw _2lx21bp4 _zulp1ejb _15tx1ejb",
                    "_cg4111ib _125x11ib _1tjq11ib",
                    "_nd5lgbua"
                ]),
                style: {
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                    "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                    "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1bah1yb4 _4cvr1h6o"
                        ]),
                        children: [
                            logoSection,
                            legacyNavigationButtons
                        ]
                    }),
                    quoteSection
                ]
            })
        ]
    });
};
const $6e4e4b8ac7dd4aed$var$lightTextCss = null;
const $6e4e4b8ac7dd4aed$var$refreshTextCss = null;
const $6e4e4b8ac7dd4aed$var$carouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshCarouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshQuoteLayoutCss = null;
const $6e4e4b8ac7dd4aed$var$refreshLogoContainerCss = null;
const $6e4e4b8ac7dd4aed$var$refreshQuoteContentCss = null;
const $6e4e4b8ac7dd4aed$var$refreshControlsContainerCss = null;
const $6e4e4b8ac7dd4aed$var$logoAndButtonContainerCss = null;
const $6e4e4b8ac7dd4aed$var$gridCss = null;
const $6e4e4b8ac7dd4aed$var$overlapGridItemCss = null;
const $6e4e4b8ac7dd4aed$var$buttonsContainerCss = null;
const $6e4e4b8ac7dd4aed$var$slideNumberCss = null;
const $6e4e4b8ac7dd4aed$var$buttonCss = null;
const $6e4e4b8ac7dd4aed$var$chevronCirlceCss = null;
const $6e4e4b8ac7dd4aed$var$hiddenCarouselContainerCss = null;
const $6e4e4b8ac7dd4aed$var$hiddenQuoteCss = null;
const $6e4e4b8ac7dd4aed$var$visibilityHiddenCss = null;
const $6e4e4b8ac7dd4aed$var$overrideQuotePadding = null;

});

parcelRegister("jiDxV", function(module, exports) {
$parcel$export(module.exports, "LogosMarquee", function () { return $c23f1eb8211a66c2$export$143c39d1bfa1977e; });
/* logos-marquee.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $cc8iN = parcelRequire("cc8iN");

var $ahmPu = parcelRequire("ahmPu");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $gIKKj = parcelRequire("gIKKj");

var $areUn = parcelRequire("areUn");

var $32ng3 = parcelRequire("32ng3");
const $c23f1eb8211a66c2$var$Logo = ({ src: src, href: href, alt: alt, ariaHidden: ariaHidden, tabIndex: tabIndex, isWacRefresh: isWacRefresh })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        "aria-hidden": ariaHidden,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: href,
            tabIndex: tabIndex,
            "data-event": "clicked",
            "data-event-component": "linkButton",
            "data-event-container": "connector",
            className: (0, $2jatx.default)([
                "_1e0c1txw _bfhk1nc2 _2rkovwyg _1bah1h6o _4cvr1h6o _tnruys9h _1rfmys9h",
                isWacRefresh ? "_bfhkcd5j _2rko1tcg _19pkt94y _1dbz130s" : "_irr35k8o"
            ]),
            style: {
                "--_yrk0lp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark100")),
                "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card")),
                "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                "--_1ntr8rj": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark200"))
            },
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_4t3i1wqb _1bsb1wqb _19pk19bv _2hwx19bv _otyr19bv _18u019bv",
                    isWacRefresh && "_4t3i8ved _1bsb8ved _19pk1trj _2hwx1trj _otyr1trj _18u01trj _tnru1wqb _1rfm1wqb _q5ug19bv _7tld19bv _14ad19bv _4uro19bv"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    src: src,
                    alt: alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $c23f1eb8211a66c2$export$143c39d1bfa1977e = ({ mobileLogos: mobileLogos, tabletLogos: tabletLogos, desktopLogos: desktopLogos })=>{
    const isWACRefreshGateEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacRefreshTeam26Gate);
    const checkWacRefreshExperiment = (0, $gIKKj.useExperiment)((0, $areUn.wacRefreshQ4Fy26Experiment));
    const isWacRefresh = isWACRefreshGateEnabled || checkWacRefreshExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && checkWacRefreshExperiment.value;
    // Default to true (running); correct to false after mount if the user prefers reduced motion.
    // We do this in useEffect (not useState initializer) to avoid SSR/hydration mismatches,
    // since window.matchMedia is not available on the server.
    const [running, setRunning] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) setRunning(false);
    }, []);
    tabletLogos = tabletLogos?.length === 0 ? desktopLogos : tabletLogos;
    mobileLogos = mobileLogos?.length === 0 ? desktopLogos : mobileLogos;
    // @ts-ignore
    const mobileLogosLength = mobileLogos.length;
    // @ts-ignore
    const tabletLogosLength = tabletLogos.length;
    const desktopLogosLength = desktopLogos.length;
    mobileLogos = [
        // @ts-ignore
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos,
        ...mobileLogos
    ];
    tabletLogos = [
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos,
        ...tabletLogos
    ];
    desktopLogos = [
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos,
        ...desktopLogos
    ];
    const intl = (0, $8e22h.default)();
    const pauseLabel = intl.formatMessage({
        id: "connector-logo-marquee.pause",
        defaultMessage: "Pause"
    });
    const playLabel = intl.formatMessage({
        id: "connector-logo-marquee.play",
        defaultMessage: "Play"
    });
    const playPauseButton = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsb1osq _1e0c1txw _1bahh9n0"
            ]),
            children: isWacRefresh ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.PlayPauseControls), {
                isPlaying: running,
                onToggle: ()=>setRunning((r)=>!r),
                mediaLabel: intl.formatMessage({
                    id: "connector-logo-marquee.media-label",
                    defaultMessage: "connector logos"
                })
            }) : /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
                onClick: ()=>setRunning((r)=>!r),
                "aria-pressed": running,
                "aria-label": running ? pauseLabel : playLabel,
                "data-event": "clicked",
                "data-event-component": "button",
                "data-event-container": "connector",
                className: (0, $2jatx.default)([
                    "_4t3i1ady _1bsb1ady _bfhk1j28 _19itglyw _2rko1osq _d0altlke"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3izwfg _1bsbzwfg _bfhkzwk4 _19itglyw _2rko1osq _1e0c1txw _1bah1h6o _4cvr1h6o _d0altlke _irr31io3 _1tjq11ib"
                    ]),
                    style: {
                        "--_qeag6c": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark400")),
                        "--_138lqrp": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark500")),
                        "--_44ufl2": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.dark1000"))
                    },
                    children: running ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cc8iN))), {
                        label: pauseLabel
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ahmPu))), {
                        label: playLabel
                    })
                })
            })
        })
    });
    const logosList = /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44vc8cz _1y0c4ukn",
                    "_16uvtrqk",
                    "_181nglyw",
                    isWacRefresh && "_85i5pxbi"
                ]),
                style: {
                    "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                },
                children: mobileLogos.map((logo, index)=>{
                    const isOriginal = index < mobileLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44v7abo _1y0c4ukn",
                    "_16uvtrqk",
                    "_dm25glyw _sugaglyw",
                    isWacRefresh && "_85i5pxbi"
                ]),
                style: {
                    "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                },
                children: tabletLogos.map((logo, index)=>{
                    const isOriginal = index < tabletLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                className: (0, $2jatx.default)([
                    "_1bsb1osq _o5721q9c",
                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _zulpv47k _1bsb1ns9",
                    "_y44vhu9l _1y0c4ukn",
                    "_16uvtrqk",
                    "_1mjbglyw",
                    isWacRefresh && "_85i5pxbi"
                ]),
                style: {
                    "--_1ikxs8u": (0, $6ZVlx.default)(running ? "running" : "paused")
                },
                children: desktopLogos.map((logo, index)=>{
                    const isOriginal = index < desktopLogosLength;
                    return /*#__PURE__*/ (0, $7VQPk.jsx)($c23f1eb8211a66c2$var$Logo, {
                        ariaHidden: !isOriginal,
                        tabIndex: isOriginal ? 0 : -1,
                        isWacRefresh: isWacRefresh,
                        ...logo
                    }, index);
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulputpp"
        ]),
        children: [
            logosList,
            playPauseButton
        ]
    });
};
const $c23f1eb8211a66c2$var$linkCss = null;
const $c23f1eb8211a66c2$var$nonRefreshLinkHoverCss = null;
const $c23f1eb8211a66c2$var$refreshLinkCss = null;
const $c23f1eb8211a66c2$var$logoCss = null;
const $c23f1eb8211a66c2$var$refreshLogoCss = null;
const $c23f1eb8211a66c2$var$listCss = null;
const $c23f1eb8211a66c2$var$refreshListPaddingCss = null;
const $c23f1eb8211a66c2$var$marqueeContainerCss = null;
const $c23f1eb8211a66c2$var$marqueeButtonContainerCss = null;
const $c23f1eb8211a66c2$var$marqueeButtonCss = null;
const $c23f1eb8211a66c2$var$buttonCirlceCss = null;
const $c23f1eb8211a66c2$var$listContainerCss = null;
const $c23f1eb8211a66c2$var$animationKeyframesCss = null;
const $c23f1eb8211a66c2$var$pauseOnHoverCss = null;
const $c23f1eb8211a66c2$var$desktopCss = null;
const $c23f1eb8211a66c2$var$tabletCss = null;
const $c23f1eb8211a66c2$var$mobileCss = null;

});


parcelRegister("i1SI4", function(module, exports) {
$parcel$export(module.exports, "CustomerTestimonials", function () { return $82b7f8eaea519598$export$ff99f9acc73d9931; });
/* customer-testimonials.tsx generated by @compiled/babel-plugin v0.28.8 */ // Initial changes from ADG4CustomerTestimonials
// Removed scroll Ref and inview tracker, since there is no longer an automatic transition to new tabs
// Removed className since it was not in use
// Removed testimonialCta since that is a non standard usage in the Confluence Product Tour and clouds the core Design Pattern
// Removed Blue as an option for backgrounds for now since that is not spec
// Removed h2 heading (that should be included as a Content Block separately going forward)
// Removed TypographyStyles wrapper for consistency with other components/patterns
// Cleaned up unused classnames within the component

var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $a9lfn = parcelRequire("a9lfn");

var $ftgEA = parcelRequire("ftgEA");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
// Not able to use wacToken function with cssMap. Need to refactor this in the future to use dynamic functions
const $82b7f8eaea519598$var$backgroundColorStyleMap = {
    black: "_bfhkr3uz",
    white: "_bfhku67f"
};
const $82b7f8eaea519598$var$backgroundShape = null;
const $82b7f8eaea519598$var$fontColorStyleMap = {
    "dark-bg": "_syaz12cp",
    "white-bg": "_syazn7od"
};
const $82b7f8eaea519598$var$topLineStyleMap = {
    black: "_bfhku67f",
    white: "_bfhkr3uz"
};
const $82b7f8eaea519598$var$logoOptionStyleMap = {
    "dark-bg": "_d4ksu67f _i862u67f _1uiy16sm",
    "white-bg": "_d4ksr3uz _i862r3uz"
};
const $82b7f8eaea519598$var$justifyContentStyleMap = {
    "dark-bg": "_1bahh9n0",
    "white-bg": "_1bah1h6o"
};
const $82b7f8eaea519598$export$ff99f9acc73d9931 = ({ bgColor: bgColor = "black", testimonials: testimonials, productKey: productKey })=>{
    const bgTheme = bgColor === "black" ? "dark-bg" : "white-bg";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4Tabs), {
        loop: true,
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _1pbykb7n _6rth1jfw",
                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme]
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                    layout: "12",
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswstnw _1r04idpf _1bsb1lk2 _p12fklux _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1rfm1osq",
                                    $82b7f8eaea519598$var$backgroundColorStyleMap[bgColor],
                                    bgColor === "black" && "_mkrzq8qa _kxoh75ra"
                                ])
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1e0c11p5 _yv0ehkll _2z05hkll _1ir7idpf _bhknkb7n _1rrs1txw _s9hn1ekt _16l7kb7n _w53ccs5v"
                                ]),
                                children: testimonials.map((testimonial, index)=>{
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4TabPanel), {
                                        id: `${index}`,
                                        panelIndex: index,
                                        forceRender: true,
                                        hideTabPanelRole: true,
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$TopRowContent, {
                                            testimonial: testimonial,
                                            index: index,
                                            bgTheme: bgTheme,
                                            bgColor: bgColor,
                                            productKey: productKey
                                        })
                                    }, index);
                                })
                            }),
                            testimonials.length > 1 && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                    className: (0, $2jatx.default)([
                                        "_1reo15vq _18m915vq _1bsb1osq _1bah1yb4 _1v611bp4 _476dgktf"
                                    ]),
                                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $a9lfn.Adg4DraggableTabList), {
                                        rowGap: "32px",
                                        className: (0, $2jatx.default)([
                                            "_6rth1fu0 _1q511aa3 _qtt8agmp"
                                        ]),
                                        children: [
                                            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                                className: (0, $2jatx.default)([
                                                    "_kqswstnw _152tt94y _1e02idpf _rjxpidpf _4t3it94y _2rkoyh40 _tzy4105o _xaej183y",
                                                    $82b7f8eaea519598$var$topLineStyleMap[bgColor]
                                                ])
                                            }),
                                            testimonials.map((testimonial, index)=>{
                                                return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $a9lfn.Adg4DraggableTab), {
                                                    as: "li",
                                                    tabIndex: index,
                                                    dataEventProps: {
                                                        "data-product-key": productKey,
                                                        "data-event-component": "tab",
                                                        "data-event-container": "testimonialsSection",
                                                        "data-event": "clicked",
                                                        "data-label-english": testimonial.label
                                                    },
                                                    label: testimonial.label,
                                                    className: (0, $2jatx.default)([
                                                        $82b7f8eaea519598$var$logoOptionStyleMap[bgTheme],
                                                        "_1e0c1txw _1bah1fhb _4cvr1fhb _kqswh2mm _1atpidpf"
                                                    ]),
                                                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($82b7f8eaea519598$var$LogoTabContent, {
                                                        testimonialLogo: testimonial.logo
                                                    })
                                                }, index);
                                            })
                                        ]
                                    })
                                })
                            })
                        ]
                    })
                })
            })
        })
    });
};
const $82b7f8eaea519598$var$TopRowContent = ({ testimonial: testimonial, index: index, bgTheme: bgTheme, bgColor: bgColor, isPanelActive: isPanelActive, productKey: productKey })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_kqswh2mm _1e0c1txw _1p57pxbi _1n261g80 _4cvr1fhb _1gde1bp4 _xsmr1h6o",
            "_6rth1ylp _1e0c11p5 _yv0ewxkt _gy1pzwfg _tzy4idpf _1pbykb7n _1ph4hkll",
            isPanelActive && "_tzy4kb7n _1pbycs5v"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_kqswh2mm _i0dlhwvj _1e0c1txw _1bah1h6o _4cvresu3 _16xt1ssb _1rfm1vuk _q5ugidpf _7tld1wug _14adidpf _4uro1wug _7bcc1n8h _18jmidpf _qji61wug _ms0lidpf _v5we1wug"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_bna7ng7t _1jtm1c95 _1fhe1c95 _1cwsdlvw _mezj1wug _v4pn1ule",
                        isPanelActive && "_m3691nt4"
                    ]),
                    children: typeof testimonial.image !== "string" && "contentType" in testimonial.image ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        ...testimonial.image
                    }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
                        image: {
                            src: testimonial.image,
                            alt: ""
                        }
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_i0dl1nrf _1reo15vq _18m915vq _bozg1b66 _85i51b66 _1a8l1ssb"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4t3i1osq _2rkogktf _kqswh2mm _19pkidpf _2hwx1wug _otyridpf _18u01wug _26vxys9h _12rr1e9y _1rfm1osq",
                        $82b7f8eaea519598$var$justifyContentStyleMap[bgTheme]
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_v5641pn7 _1e0c1txw _2lx21bp4 _zulp1tcg",
                            isPanelActive && "_y44v13sw _11vozap6"
                        ]),
                        children: [
                            testimonial.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "eyebrow-md"
                                ]),
                                children: testimonial.eyebrow
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("blockquote", {
                                className: (0, $2jatx.default)([
                                    $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                                    "callout"
                                ]),
                                children: [
                                    "\u201C",
                                    testimonial.quote,
                                    "\u201D"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsxs)("p", {
                                className: (0, $2jatx.default)([
                                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                                ]),
                                children: [
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "eyebrow-lg"
                                        ]),
                                        children: testimonial.name
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            $82b7f8eaea519598$var$fontColorStyleMap[bgTheme],
                                            "body-md title"
                                        ]),
                                        children: testimonial.title
                                    })
                                ]
                            }),
                            testimonial.link ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                                anchorProps: {
                                    tabIndex: isPanelActive ? 0 : -1
                                },
                                text: testimonial.link.text,
                                href: testimonial.link.url,
                                type: testimonial.link.type ?? "primary",
                                bgColor: bgColor === "black" ? "bgBlackBlue" : "bgWhite",
                                "aria-label": testimonial.link.text,
                                dataEventProps: testimonial.link.dataEventProps ?? {
                                    "data-product-key": productKey,
                                    "data-event-component": "linkButton",
                                    "data-event-container": "testimonialsSection",
                                    "data-event": "clicked"
                                }
                            }) : null
                        ]
                    }, index)
                })
            })
        ]
    });
};
const $82b7f8eaea519598$var$topRowActiveStyle = null;
const $82b7f8eaea519598$var$customerImagesImgActiveStyle = null;
const $82b7f8eaea519598$var$quoteContainerActiveStyle = null;
const $82b7f8eaea519598$var$LogoTabContent = ({ testimonialLogo: testimonialLogo, isSelected: isSelected = false })=>{
    const isContentfulImage = "contentType" in testimonialLogo;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_tzy4kb7n _kqswstnw _152tj39m _1e02idpf _rjxpidpf _4t3i14y2 _2rkoyh40",
                    "top-marker"
                ])
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                className: (0, $2jatx.default)([
                    "_11q7glyw _19itidpf _r06hglyw _1q51gktf _80omtlke _kqswh2mm"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                    className: (0, $2jatx.default)([
                        "_tzy4105o _v5641bs3 _16l4kb7n",
                        "_4t3i1u1b _1e0c1txw _4cvr1h6o",
                        isSelected && "_tzy4kb7n"
                    ]),
                    children: isContentfulImage ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $ftgEA.ContentPlatformImage), {
                        ...testimonialLogo,
                        width: "140",
                        height: "34",
                        style: {
                            objectFit: "contain",
                            objectPosition: "center center"
                        },
                        className: "tab-logo"
                    }) : testimonialLogo
                })
            })
        ]
    });
};
// LogoTabContent styles
const $82b7f8eaea519598$var$logoImgStyle = null;
const $82b7f8eaea519598$var$logoImgSelectedStyle = null;
const $82b7f8eaea519598$var$logoButtonStyle = null;
const $82b7f8eaea519598$var$topMarkerStyle = null;
const $82b7f8eaea519598$var$logoImgContainerStyle = null;
// ADG4CustomerTestimonials styles
const $82b7f8eaea519598$var$topLineStyles = null;
const $82b7f8eaea519598$var$testimonialKeyframeStyles = null;
const $82b7f8eaea519598$var$rowWidthStyle = null;
const $82b7f8eaea519598$var$topRowStyle = null;
const $82b7f8eaea519598$var$bgShapeStyle = null;
const $82b7f8eaea519598$var$customerImagesSectionStyles = null;
const $82b7f8eaea519598$var$customerImagesSectionImageStyles = null;
const $82b7f8eaea519598$var$customerQuotesSectionStyle = null;
const $82b7f8eaea519598$var$testimonialQuotesSectionStyle = null;
const $82b7f8eaea519598$var$quoteContainerStyle = null;
const $82b7f8eaea519598$var$quoteContainerPStyle = null;
const $82b7f8eaea519598$var$logosContainerBaseStyle = null;
const $82b7f8eaea519598$var$logosStyle = null;
const $82b7f8eaea519598$var$logoOptionStyle = null;
const $82b7f8eaea519598$var$testimonialStyles = null;
const $82b7f8eaea519598$var$tabPanelWrapperStyles = null;

});

parcelRegister("anFhN", function(module, exports) {
$parcel$export(module.exports, "FeaturesHighlight", function () { return $00c15acb18b151d4$export$bf20c48d528647dd; });
/* features-highlight.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $1oC0p = parcelRequire("1oC0p");

var $ggSCt = parcelRequire("ggSCt");

var $imIsw = parcelRequire("imIsw");

var $2fk4i = parcelRequire("2fk4i");

var $lE15B = parcelRequire("lE15B");

var $kbpa7 = parcelRequire("kbpa7");
const $00c15acb18b151d4$export$bf20c48d528647dd = (props)=>{
    const [activeFeature, setActiveFeature] = (0, (/*@__PURE__*/$parcel$interopDefault($1oC0p))).useState(0);
    const onFeatureSelect = (featureKey)=>{
        setActiveFeature(featureKey);
    };
    const singleFeature = (content, featureKey)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            onClick: ()=>onFeatureSelect(featureKey),
            onKeyDown: (e)=>{
                if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    onFeatureSelect(featureKey);
                }
            },
            className: (0, $2jatx.default)([
                "_80omtlke _kqswh2mm _u5ggpxbi _11xx17la _uoz5x71z _suga1ule _1ah31y44",
                `feature ${activeFeature === featureKey ? "selected" : ""}`
            ]),
            role: "tab",
            tabIndex: 0,
            style: {
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
            },
            children: [
                activeFeature === featureKey && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_kqswstnw _1pbykb7n _bfhk17la _2rko1y44 _1bsb1osq _4t3iftgi _165t1osq _glteftgi"
                    ]),
                    style: {
                        "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                    }
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_owpupxbi _6ssjpxbi"
                    ]),
                    children: content
                })
            ]
        });
    const feature1Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature1Title,
        titleAs: "h3",
        text: props.feature1Body,
        eyebrow: props.feature1Eyebrow,
        alignment: "start"
    });
    const feature1Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature1ImageSrc,
            alt: props.feature1ImageAltText ?? "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature1Video = props.feature1VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature1VideoSrc,
        poster: props.feature1VideoPoster,
        alt: props.feature1VideoAltText ?? ""
    }, "feature1-video") : null;
    const feature2Video = props.feature2VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature2VideoSrc,
        poster: props.feature2VideoPoster,
        alt: props.feature2VideoAltText ?? ""
    }, "feature2-video") : null;
    const feature3Video = props.feature3VideoSrc ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lE15B.Video), {
        src: props.feature3VideoSrc,
        poster: props.feature3VideoPoster,
        alt: props.feature3VideoAltText ?? ""
    }, "feature3-video") : null;
    const feature2Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature2Title,
        titleAs: "h3",
        text: props.feature2Body,
        eyebrow: props.feature2Eyebrow,
        alignment: "start"
    });
    const feature2Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature2ImageSrc,
            alt: props.feature2ImageAltText ?? "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const feature3Text = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
        title: props.feature3Title,
        titleAs: "h3",
        text: props.feature3Body,
        eyebrow: props.feature3Eyebrow,
        alignment: "start"
    });
    const feature3Image = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $imIsw.Picture), {
        image: {
            src: props.feature3ImageSrc,
            alt: props.feature3ImageAltText ?? "",
            style: {
                width: "100%",
                height: "auto"
            }
        },
        style: {
            width: "100%",
            height: "auto"
        }
    });
    const featureTexts = [
        feature1Text,
        feature2Text,
        props.feature3Title && feature3Text
    ];
    const content = [
        props.feature1ImageSrc ? feature1Image : feature1Video,
        props.feature2ImageSrc ? feature2Image : feature2Video,
        props.feature3Title && props.feature3ImageSrc ? feature3Image : feature3Video
    ];
    const sectionContainerStyles = null;
    const topContentContainerStyles = null;
    const featuresContainerStyles = null;
    const imageContainerStyles = null;
    const navDotsContainerStyles = null;
    const navDot = (featureNum)=>{
        return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1bsbftgi _4t3iftgi _2rko1y44 _bfhk1cls"
            ]),
            style: {
                "--_1lhuu6n": (0, $6ZVlx.default)(featureNum === activeFeature ? (0, $kbpa7.wacToken)("color.primary.black") : (0, $kbpa7.wacToken)("color.neutral.light500"))
            }
        });
    };
    // @ts-ignore
    const navDotsContainer = (_)=>/*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _zulppxbi _1bah1h6o _1q51pxbi"
            ]),
            children: featureTexts.map((_, index)=>navDot(index))
        });
    const mobileCarouselContainerStyles = null;
    const sliderSettings = {
        dots: true,
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        afterChange: (current)=>setActiveFeature(current),
        appendDots: navDotsContainer
    };
    const featureSlideStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_15fl1wug _1d2w1wug _1svy1wug _seov1wug _16imoahv _b8yq1osq _14b51osq _su071wqb _1j8bcx6w _181n11p5 _dwk3usvi _19wg14hz _11mz1tcg _owpu1wqb _10jxzqdx _1vsw1vi7 _suga1txw _1gde1bp4 _1rfm1osq _tnru1osq _8164pxbi _133i1jfw"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1rfm1osq _xlt11ejb _s51szwfg _uoz5179g _1e3ceqnf _1e0c1txw _2lx21bp4 _zulpu2gc _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                        title: props.title,
                        titleAs: "h2",
                        text: props.description,
                        alignment: "center"
                    }),
                    props.linkText && props.linkHref && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Link), {
                        text: props.linkText,
                        href: props.linkHref,
                        "aria-label": props.linkText
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tablist",
                className: (0, $2jatx.default)([
                    "_1e3cx71z _dm251txw _1ini1bp4 _kzvi1bgi _1e0cglyw"
                ]),
                children: featureTexts.map((feature, index)=>singleFeature(feature, index))
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                role: "tabpanel",
                className: (0, $2jatx.default)([
                    "_1e3cthi2 _165t1osq _uoz5uufb _sugaglyw"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    children: content[activeFeature]
                }, activeFeature)
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0cglyw _suga1ule",
                    "_vnijh2mm _1ls01ule _1dtvusvi _1kb1glyw _fjwtglyw _1wv2glyw _1r6vglyw _zookglyw _8rkdglyw _1tpbmuzh _u8dlmuzh _e1ct1j28 _1t25h2mm _ll151ule _8lsh15vq _kuv715vq _19moidpf _1vqqidpf _m8oxidpf _bzd2idpf _zwvbidpf _19wzidpf _2awfidpf _l1guidpf _3otn1r31 _1d59glyw _r3kx1o36 _1y6utlke _1t6x161g _1u6z161g _1vpa161g _5skb161g _1xca161g _xcl1161g _rzx1161g _1xcr161g _57of161g _b29h161g _snlxh2mm _1rfpidpf _104oidpf _j6fg1ule _gkdh1wug _1jbo1wug _1qa65mfb _r4f35mfb _y1t8b3bt _1v9lb3bt _v42h1hrf _1t4e15vq _1u35glyw _1vrb1e5h _m8yv1osq _gzcot94y _tovh1txw _160x1h6o _1a23usic _k4vw1ule _19i1glyw _1afyglyw _1xnx1ule _qzmo15vq _1xzb1ule _ntpm1wug _4v68okh7 _13h3glyw",
                    "slider-container"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggSCt))), {
                    ...sliderSettings,
                    children: featureTexts.map((feature, index)=>/*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                            className: (0, $2jatx.default)([
                                "_18zrzwfg _1e0c1txw _2lx21bp4 _zulppxbi"
                            ]),
                            children: [
                                singleFeature(feature, index),
                                content[index]
                            ]
                        }, index))
                })
            })
        ]
    });
};
// Source https://github.com/kenwheeler/slick/blob/master/slick/slick.css
const $00c15acb18b151d4$var$slickStyle = null;

});

parcelRegister("8J2ZV", function(module, exports) {
$parcel$export(module.exports, "default", function () { return $3798516d873ca4cc$export$2e2bcd8739ae039; });
/* hero.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $lqyi6 = parcelRequire("lqyi6");

var $bSVv5 = parcelRequire("bSVv5");

var $kbpa7 = parcelRequire("kbpa7");
const $3798516d873ca4cc$export$887967f05dc521ae = ({ layout: layout = "image-right", ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        style: {
            "--background-color": `${props.backgroundColor ? (0, $kbpa7.wacToken)(props.backgroundColor) : "transparent"}`
        },
        className: (0, $2jatx.default)([
            "_11q76ulk"
        ]),
        children: layout === "image-both" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroBothImages, {
            ...props
        }) : layout === "no-image" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroNoImage, {
            ...props
        }) : layout === "image-below" ? /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroImageBelow, {
            ...props
        }) : /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeroOneImage, {
            layout: layout,
            ...props
        })
    });
};
var $3798516d873ca4cc$export$2e2bcd8739ae039 = $3798516d873ca4cc$export$887967f05dc521ae;
const $3798516d873ca4cc$var$DARK_BKGD_COLORS = [
    "color.primary.black"
];
const $3798516d873ca4cc$var$HeadingContent = ({ heading: heading, subheading: subheading, callToActionProps: callToActionProps, size: size = "regular", backgroundColor: backgroundColor })=>{
    const { text: buttonText, ...buttonProps } = callToActionProps ?? {};
    const isLarge = size === "large";
    const useLightText = backgroundColor ? $3798516d873ca4cc$var$DARK_BKGD_COLORS.includes(backgroundColor) : false;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)("h1", {
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                className: (0, $2jatx.default)([
                    "_18s8ze3t",
                    isLarge ? "superhero" : undefined
                ]),
                children: heading
            }),
            subheading && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_1pfhu2gc _6rthze3t",
                    isLarge ? "body-lg" : "body-md"
                ]),
                style: {
                    color: useLightText ? (0, $kbpa7.wacToken)("color.neutral.light0") : "inherit"
                },
                children: subheading
            }),
            buttonText && buttonProps && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1q51xy5q"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
                    ...buttonProps,
                    size: "large",
                    children: buttonText
                })
            })
        ]
    });
};
const $3798516d873ca4cc$var$HeroOneImage = ({ layout: layout = "image-right", imageProps: imageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "12",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c11p5 _zulp1ejb _1rjc1jfw _y3gn1h6o _4cvr1h6o _1j8bwxkt _lagd18l3 _19wgxy5q _uj6kv2br _1ooboahv _1s0lxncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        layout === "image-left" && "_1b1qcs5v"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                        ...props
                    })
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                    maxPossibleWidth: 700,
                    src: imageProps.src,
                    alt: imageProps.alt ?? "",
                    loading: "eager",
                    width: imageProps.width,
                    height: imageProps.height
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$gridStyle = null;
const $3798516d873ca4cc$var$headingStyle = null;
const $3798516d873ca4cc$var$imageStartStyle = null;
const $3798516d873ca4cc$var$bodyStyle = null;
const $3798516d873ca4cc$var$buttonWrapperStyle = null;
/*
This is an experimental start to support the needs of the Hero variation with images on the sides, primary content centered
Initial support is seen on Product enterprise pages (such as /software/jira/enterprise) as served by WAC Authoring Engine

TODO: We need to understand the levels of configurability desired/needed to support a variety of use cases, collab with design.
  Currently it is very tailored to the aforementioned enterprise experience. 
  We may need to ensure we use Image so that we can add an alt text if needed.
*/ const $3798516d873ca4cc$var$HeroBothImages = ({ imageProps: imageProps, secondaryImageProps: secondaryImageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1reo15vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
            layout: "12",
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_uaqo1x3a _13j917im",
                    "_kqswh2mm _1e0c11p5 _10fp1h6o _y3gn1h6o _4cvr1h6o _6a6z1h6o _1rjc1jfw _14b51ssb _su07u2gc _1ooboahv _1s0lxncg _bxthb3bt _t4hxstnw _1yp51osq _1bpvsmen _brhgmgnk _5kbx1f51 _1gg8w2la _n4lfidpf _1nls12it _14xsidpf _16bh12it _1z0y9by0 _ixsu1osq _a6uwb3bt _dbttstnw _83tk1wn5 _10wjmgnk _tzs91f51 _wi3i1048 _1x65idpf _oppa12it _1ohy1kly _nd8fidpf _1yam12it _ugza1kly _mlxy9by0 _k4z51osq _xcpbpwvu"
                ]),
                style: {
                    "--_1thiznr": (0, $6ZVlx.default)(imageProps ? `url(${imageProps.src})` : "none"),
                    "--_c31b9r": (0, $6ZVlx.default)(secondaryImageProps ? `url(${secondaryImageProps.src})` : "none")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                    ...props,
                    size: "regular"
                })
            })
        })
    });
};
const $3798516d873ca4cc$var$gridTwoImagesStyle = null;
const $3798516d873ca4cc$var$HeroNoImage = (props)=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1rjc1jfw _1ooboahv _1s0lxncg",
                "_85i5xncg"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                ...props
            })
        })
    });
};
const $3798516d873ca4cc$var$centerTextWrapperStyle = null;
const $3798516d873ca4cc$var$noImageBottomPaddingStyle = null;
const $3798516d873ca4cc$var$HeroImageBelow = ({ imageProps: imageProps, ...props })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
        layout: "10",
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bsb1osq _85i5xncg"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _2lx21bp4 _4cvr1h6o _y3gn1h6o _1rjc1jfw _1ooboahv _1s0lxncg"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($3798516d873ca4cc$var$HeadingContent, {
                        ...props
                    })
                }),
                imageProps && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_1bsb1osq _1pfhxy5q _1nlx1osq _mezj1osq _v4pn1ule"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $bSVv5.Image), {
                        src: imageProps.src,
                        alt: imageProps.alt ?? "",
                        loading: "eager",
                        width: imageProps.width,
                        height: imageProps.height
                    })
                })
            ]
        })
    });
};
const $3798516d873ca4cc$var$imageBelowContainerStyle = null;
const $3798516d873ca4cc$var$imageBelowImageWrapperStyle = null;

});

parcelRegister("us1N6", function(module, exports) {
$parcel$export(module.exports, "HeroCarousel", function () { return $13e2b0d7d2657b7f$export$b92905002f03c113; });
/* hero-carousel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $jKShK = parcelRequire("jKShK");

var $8EEDU = parcelRequire("8EEDU");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");

var $lqyi6 = parcelRequire("lqyi6");

var $iPPTB = parcelRequire("iPPTB");
const $13e2b0d7d2657b7f$export$b92905002f03c113 = ({ tabsData: tabsData })=>{
    const [selectedTab, setSelectedTab] = (0, $1oC0p.useState)(0);
    const listRef = (0, $1oC0p.useRef)(null);
    const { ref: lastTabRef, inView: isTabListEndVisible } = (0, $jKShK.useInView)({
        root: listRef?.current,
        threshold: 1
    });
    const { ref: firstTabRef, inView: isTabListStartVisible } = (0, $jKShK.useInView)({
        root: listRef?.current,
        threshold: 1
    });
    (0, $1oC0p.useEffect)(()=>{
        const listElement = listRef?.current;
        if (listElement) {
            const tabElement = listElement.children?.[selectedTab + 1];
            if (tabElement && typeof tabElement.scrollIntoView === "function") {
                tabElement.scrollIntoView({
                    behavior: "smooth",
                    inline: "center",
                    block: "end"
                });
                tabElement.focus();
            }
        }
    }, [
        selectedTab
    ]);
    const onKeyDown = (e)=>{
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
            let newFocusIndex = 0;
            if (e.key === "ArrowRight") {
                newFocusIndex = selectedTab + 1;
                if (newFocusIndex >= tabsData.length) newFocusIndex = 0;
            } else if (e.key === "ArrowLeft") {
                newFocusIndex = selectedTab - 1;
                // If we're at the start, move to the end
                if (newFocusIndex < 0) newFocusIndex = tabsData.length - 1;
            }
            setSelectedTab(newFocusIndex);
        }
    };
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "hero-carousel",
        "data-testid": "hero-carousel",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21sxn _1bsb1osq _1reo15vq _18m915vq"
            ]),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$TabList, {
                    listRef: listRef,
                    isTabListViewable: isTabListStartVisible && isTabListEndVisible,
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: firstTabRef
                        }),
                        tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsxs)($13e2b0d7d2657b7f$var$Tab, {
                                isSelected: i === selectedTab,
                                id: tab.id,
                                onClick: ()=>{
                                    setSelectedTab(i);
                                },
                                onKeyDown: onKeyDown,
                                children: [
                                    tab.eyebrow && /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "eyebrow-sm"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.eyebrow
                                    }),
                                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                                        className: (0, $2jatx.default)([
                                            "_syazcd5j _y3gnv2br _19pkidpf _2hwxidpf _otyridpf _18u0idpf _tzy4105o _v564177f",
                                            "_syazcd5j _1wyb1j6v _k48pni7l _vwz410nf"
                                        ]),
                                        style: {
                                            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                                        },
                                        children: tab.title
                                    })
                                ]
                            }, tab.id)),
                        /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                            ref: lastTabRef
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContainer, {
                    children: tabsData.map((tab, i)=>/*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$Panel, {
                            isSelected: i === selectedTab,
                            id: tab.id,
                            panel: tab.panel,
                            titleAs: i === 0 ? "h1" : "h2"
                        }, tab.id))
                })
            ]
        })
    });
};
var $13e2b0d7d2657b7f$export$2e2bcd8739ae039 = $13e2b0d7d2657b7f$export$b92905002f03c113;
const $13e2b0d7d2657b7f$var$TabList = ({ children: children, listRef: listRef, isTabListViewable: isTabListViewable })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_11q71hlo _1bsb1osq _syazcd5j _1reo15vq _18m915vq _18zrzwfg _su071wqb"
        ]),
        style: {
            "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-ignore
            ref: listRef,
            tabIndex: -1,
            role: "tablist",
            className: (0, $2jatx.default)([
                "_1tkegad4 _1e0c1txw _qtt8glyw _1mouidpf _195g1wug _18zridpf _1rjcie5z _1reo15zi _rjfvx6dd _b8yqzqdx _zcekze3t _kpfhglyw",
                isTabListViewable && "_1bah1h6o"
            ]),
            children: children
        })
    });
};
const $13e2b0d7d2657b7f$var$Tab = ({ children: children, isSelected: isSelected, id: id, onClick: onClick, onKeyDown: onKeyDown })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("button", {
        type: "button",
        tabIndex: isSelected ? 0 : -1,
        role: "tab",
        "aria-selected": isSelected ? "true" : "false",
        "aria-controls": `hero-panel-${id}`,
        id: `hero-tab-${id}`,
        onClick: onClick,
        onKeyDown: onKeyDown,
        "data-label": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_mqm21kma _v564ucvz _179rglyw _h7alglyw _r06hglyw _bfhk1j28 _ect41kw7 _1wyb1j6v _1bsb1ltq _1ul91ltq _80omtlke _1hu1v2br _1rjcu2gc _18zr1ejb _4cvrv2br _1e0c1txw _2lx21bp4 _zulp12x7 _oxutkb7n _svxhkb7n",
            isSelected && "_mqm25cav _1wk5kb7n"
        ]),
        style: {
            "--_jxcf9d": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.saffron"))
        },
        children: children
    });
};
const $13e2b0d7d2657b7f$var$PanelContainer = ({ children: children })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        className: (0, $2jatx.default)([
            "_1e0c11p5"
        ]),
        children: children
    });
};
const $13e2b0d7d2657b7f$var$Panel = ({ isSelected: isSelected, id: id, panel: panel, ...props })=>{
    const [isModalOpen, setIsModalOpen] = (0, $1oC0p.useState)(false);
    const baseStyle = null;
    const isVideoLink = panel.secondaryCallToAction?.type === "video";
    const isForegroundLight = [
        "blue",
        "black"
    ].includes(panel.bgColor);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        role: "tabpanel",
        id: `hero-panel-${id}`,
        "data-testid": `hero-panel-${id}`,
        "aria-hidden": !isSelected,
        "aria-labelledby": `hero-tab-${id}`,
        className: (0, $2jatx.default)([
            "_v564twcc _yyhy183o _1ii7183o _1e0c11p5 _tzy4idpf _1pby1mrw _kqswh2mm",
            isSelected && "_tzy4kb7n _1pbykb7n",
            "_1kt9b3bt _1g0v1mrw _1cs8stnw _1tesidpf _1rusu6yl _aetrb3bt _1bqq1mrw _18postnw _16gxidpf _z0ai1osq _wbcj14i6 _1kje1h6o _1hfku6yl _1a1fdirt _19h91dfr _z0bc12wd"
        ]),
        style: {
            "--bg-color": panel.bgColor === "neutral" ? (0, $kbpa7.wacToken)(`color.neutral.light200`) : (0, $kbpa7.wacToken)(`color.primary.${panel.bgColor}`),
            "--_1gk99st": (0, $6ZVlx.default)(panel.bgImage?.lg ? `url(${panel.bgImage.lg})` : undefined),
            "--_xe4ghn": (0, $6ZVlx.default)(panel.layout === "end" ? "0% 50%" : "center center")
        },
        children: [
            isVideoLink && /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Modal), {
                isOpen: isModalOpen,
                closeModal: ()=>{
                    setIsModalOpen(false);
                },
                closeLabel: "Close video",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $8EEDU.default), {
                    muted: false,
                    videoType: "mp4",
                    videoLink: panel.secondaryCallToAction?.href
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_yyhy183o _1ii7183o _18zrzwfg _1rjcxncg _1e0c11p5 _19pk1wug _2hwx1wug _otyr1wug _18u01wug _zulp1ejb _1qon1h6o _1lb81h6o _5qqy1h6o _su071wqb _1rqtcx6w _pdlmxy5q _10jxzqdx",
                    isForegroundLight && "_cg41121t _125x121t",
                    panel.layout === "end" ? "_1uyy1d44 _1cxzv2br _10wbv2br _s0n3v2br" : panel.layout === "start" ? "_1uyy1vi5 _1cxzv2br _10wbv2br _s0n3v2br" : "_1uyyeqnf"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelContent, {
                        panel: panel,
                        titleAs: props.titleAs
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PanelActions, {
                        ...panel,
                        onVideoClick: isVideoLink ? (e)=>{
                            e.preventDefault();
                            e.stopPropagation();
                            setIsModalOpen(true);
                        } : undefined
                    })
                ]
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelContent = ({ panel: panel, ...props })=>{
    const { titleAs: Title = "h2" } = props;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $7VQPk.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)(Title, {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "h1"
                ]),
                children: panel.title
            }),
            panel.body && /*#__PURE__*/ (0, $7VQPk.jsx)("p", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                    "body-lg"
                ]),
                children: panel.body
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PanelActions = (panel)=>{
    return panel && /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _1bah1h6o _1n261g80 _zulp1ejb",
            (panel.layout === "start" || panel.layout === "end") && "_msupv2br"
        ]),
        children: [
            panel.primaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$PrimaryCallToAction, {
                bgColor: panel.bgColor,
                ...panel.primaryCallToAction
            }),
            panel.secondaryCallToAction && /*#__PURE__*/ (0, $7VQPk.jsx)($13e2b0d7d2657b7f$var$SecondaryCallToAction, {
                ...panel
            })
        ]
    });
};
const $13e2b0d7d2657b7f$var$PrimaryCallToAction = (props)=>{
    const { bgColor: bgColor, ...rest } = props;
    let variant = "primary";
    if (bgColor === "blue") variant = "primary_alt";
    return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $lqyi6.Button), {
        ...rest,
        variant: variant,
        "data-testid": "primary-cta",
        children: props.text
    });
};
const $13e2b0d7d2657b7f$var$SecondaryCallToAction = (panel)=>{
    const { secondaryCallToAction: secondaryCallToAction } = panel;
    const bgColor = [
        "blue",
        "black"
    ].includes(panel.bgColor) ? "bgBlackBlue" : "bgWhite";
    return(// @ts-ignore
    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $iPPTB.Link), {
        ...secondaryCallToAction,
        bgColor: bgColor,
        anchorProps: {
            "data-testid": "secondary-cta"
        },
        onClick: panel.onVideoClick,
        onKeyDown: panel.onVideoClick,
        role: "button",
        tabIndex: 0,
        children: secondaryCallToAction?.text
    }));
};
const $13e2b0d7d2657b7f$var$sectionStyles = null;
const $13e2b0d7d2657b7f$var$tabListStyle = null;
const $13e2b0d7d2657b7f$var$scrollableStyle = null;
const $13e2b0d7d2657b7f$var$fittableStyle = null;
const $13e2b0d7d2657b7f$var$tabStyle = null;
const $13e2b0d7d2657b7f$var$tabTextStyle = null;
const $13e2b0d7d2657b7f$var$tabTitleStyle = null;
const $13e2b0d7d2657b7f$var$tabSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelContainerStyle = null;
const $13e2b0d7d2657b7f$var$panelStyle = null;
const $13e2b0d7d2657b7f$var$panelSelectedStyle = null;
const $13e2b0d7d2657b7f$var$panelDetailsStyle = null;
const $13e2b0d7d2657b7f$var$panelEndStyle = null;
const $13e2b0d7d2657b7f$var$panelStartStyle = null;
const $13e2b0d7d2657b7f$var$panelCenteredStyle = null;
const $13e2b0d7d2657b7f$var$detailsTextStyle = null;
const $13e2b0d7d2657b7f$var$panelColorStyle = null;
const $13e2b0d7d2657b7f$var$actionContainerStyle = null;
const $13e2b0d7d2657b7f$var$actionStartStyle = null;

});

parcelRegister("ifNiy", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $945afc5e0498e2e0$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $945afc5e0498e2e0$var$logoSizes = {
    regular: {
        size: "78px",
        cornerRadius: "18.7px"
    },
    large: {
        size: "100px",
        cornerRadius: "24px"
    }
};
const $945afc5e0498e2e0$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImageContainerStyles = null;
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1bsbcae7 _4t3icae7 _bfhkcd5j _19it1k0a _2rko13r7 _gltef22m _165tf22m _2oz41w8s _1dbz130s"
        ]),
        style: {
            "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300")),
            "--_1jpuyj7": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].size),
            "--_1k7rxgg": (0, $6ZVlx.default)($945afc5e0498e2e0$var$logoSizes[props.logoSize].cornerRadius)
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            ...props.dataEventProps ?? {},
            className: (0, $2jatx.default)([
                "_1e0c1txw _4t3i1osq _1bsb1osq _4cvr1h6o _1bah1h6o _1yt4u2gc"
            ]),
            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbsq37 _4t3isbdl"
                ]),
                style: {
                    "--_1hn5070": (0, $6ZVlx.default)(props.width ? `${props.width}px` : "100%"),
                    "--_1jk4xy3": (0, $6ZVlx.default)(props.width ? "auto" : "100%")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    src: props.src,
                    alt: props.alt,
                    style: {
                        width: "100%",
                        height: "100%",
                        objectFit: "contain"
                    }
                })
            })
        })
    });
};
const $945afc5e0498e2e0$export$8912007324034abd = ({ eyebrow: eyebrow, title: title, titleAs: titleAs = "h3", titleAppearsAs: titleAppearsAs, body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, logos: logos, background: background = "polygon", backgroundColor: backgroundColor = "neutral.light100", flipLayout: flipLayout = false })=>{
    const numLogos = logos.filter((logo)=>logo.href ?? false).length;
    const logoSize = numLogos <= 6 ? "large" : "regular";
    const responsiveSectionDividerHeightsStyles = null;
    const sectionStyles = null;
    const polygonStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _kqswh2mm _1moul8wr _11q7fulm _1rjcq9zu",
            "_9luy1wqb _ce5au29b _wfa7llbu"
        ]),
        style: {
            "--_pxzrua": (0, $6ZVlx.default)(background === "full" ? 0 : "var(--ds-space-800, 64px)"),
            "--_1sgx88i": (0, $6ZVlx.default)(background === "full" ? (0, $kbpa7.wacToken)(`color.${backgroundColor}`) : "transparent")
        },
        children: [
            background === "polygon" && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_11q71xvm _kqswstnw _1bsb1osq _4t3imhst _14b5zqdx _b8yq87gh _1e021ssb _t9eczr6s _1kt9b3bt _1cs8stnw _iajm14o7 _kfgtq9zu _1mp41osq _1s6k1xvm _tgsmcdv4 _aetrb3bt _18postnw _1qdgq9zu _19nq1osq _z0ai1osq _16r21xvm _1oj41mhh"
                ]),
                style: {
                    "--_vp2za": (0, $6ZVlx.default)((0, $kbpa7.wacToken)(`color.${backgroundColor}`))
                }
            }),
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_195g1wug _p12f1osq _1bsb1osq _kqswh2mm _1pbykb7n _13ltwklj _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1e0c11p5 _vchhusvi _zulp14hz _1dsl1tcg _4t3i1osq _4cvr1h6o"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _p12f1to9 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q _8fz6nklw _688gkb7n",
                            flipLayout && "_1f49kb7n",
                            numLogos === 7 && "_w9am12am _1bhm12am"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($945afc5e0498e2e0$var$IntegrationLogo, {
                                ...logo,
                                logoSize: logoSize,
                                dataEventProps: logo.dataEventProps ?? logoLinkDataEventProps
                            }, index))
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                        eyebrow: eyebrow,
                        title: title,
                        titleAs: titleAs,
                        titleAppearsAs: titleAppearsAs,
                        text: body,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref,
                                ...linkDataEventProps && {
                                    dataEventProps: linkDataEventProps
                                }
                            }
                        } : undefined,
                        alignment: {
                            mobile: "center",
                            tablet: "start",
                            desktop: "start"
                        }
                    })
                ]
            })
        ]
    });
};
const $945afc5e0498e2e0$var$contentContainerStyles = null;
const $945afc5e0498e2e0$var$logosContainerStyles = null;
const $945afc5e0498e2e0$var$sevenLogosGridStyles = null;

});

parcelRegister("3OVYv", function(module, exports) {
$parcel$export(module.exports, "Integration", function () { return $a9c45609cd9ba3bf$export$8912007324034abd; });
/* integration.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $a9c45609cd9ba3bf$var$IntegrationLogo = (props)=>{
    const logoListItemStyles = null;
    const logoLinkStyles = null;
    const logoImage = /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
        src: props.src,
        alt: props.alt,
        style: {
            width: "100%",
            height: "100%",
            objectFit: "contain"
        }
    });
    if (!props.clickable) return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsbys9h _4t3iys9h _glte53f4 _165t53f4"
        ]),
        children: logoImage
    });
    if (!props.href) return null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
        className: (0, $2jatx.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1bsbys9h _4t3iys9h _glte53f4 _165t53f4"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
            href: props.href,
            ...props.dataEventProps ?? {},
            className: (0, $2jatx.default)([
                "_4t3i1osq _1bsb1osq _1hbx1doa _skp01k4l"
            ]),
            children: logoImage
        })
    });
};
const $a9c45609cd9ba3bf$export$8912007324034abd = ({ title: title, titleAs: titleAs = "h3", titleAppearsAs: titleAppearsAs, body: body, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, logoLinkDataEventProps: logoLinkDataEventProps, clickableLogos: clickableLogos = true, logos: logos })=>{
    const sectionStyles = null;
    const responsiveButtonSize = {
        mobile: "small",
        tablet: "small",
        desktop: "large",
        xl_desktop: "large"
    };
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1bsb1osq _11q71rga _1e0c1txw _2lx21bp4 _zulpxncg _1rjcxncg _19wg1epz _16im1epz _pdlm16xz _1s0l16xz"
        ]),
        style: {
            "--_1nu1zxz": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light100"))
        },
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "8",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                    title: title,
                    titleAs: titleAs,
                    titleAppearsAs: titleAppearsAs,
                    text: body,
                    callToActionProps: linkLabel && linkHref ? {
                        button: {
                            href: linkHref
                        },
                        buttonText: linkLabel,
                        buttonVariant: "secondary",
                        responsiveSize: responsiveButtonSize,
                        ...linkDataEventProps && {
                            dataEventProps: linkDataEventProps
                        }
                    } : undefined,
                    alignment: {
                        mobile: "center",
                        tablet: "center",
                        desktop: "center"
                    }
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                layout: "12",
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                    className: (0, $2jatx.default)([
                        "_1e0c1txw _1n261g80 _195g1wug _2mzuglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bah1h6o _4cvr1h6o _1p571ejb _gy1pxy5q"
                    ]),
                    children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)($a9c45609cd9ba3bf$var$IntegrationLogo, {
                            ...logo,
                            dataEventProps: logo.dataEventProps ?? logoLinkDataEventProps,
                            clickable: clickableLogos
                        }, index))
                })
            })
        ]
    });
};
const $a9c45609cd9ba3bf$var$logosContainerStyles = null;

});

parcelRegister("behZZ", function(module, exports) {
$parcel$export(module.exports, "Logos", function () { return $511c14fce74817fd$export$c847549a613b9060; });
/* logos.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");
parcelRequire("6aliX");
var $jElRc = parcelRequire("jElRc");

var $kbpa7 = parcelRequire("kbpa7");

var $gIKKj = parcelRequire("gIKKj");

var $areUn = parcelRequire("areUn");

var $32ng3 = parcelRequire("32ng3");
/**
 * Measures the logos list and computes:
 * - `maxWidth`: a pixel budget to apply to the <ul> so flex-wrap distributes
 *   logos into evenly-sized rows (same row count, balanced widths).
 * - `overflowsViewport`: true when all logos can't fit on one row, meaning the
 *   marquee should be shown instead.
 */ function $511c14fce74817fd$var$useBalancedMaxWidth(logoCount) {
    const wrapperRef = (0, $1oC0p.useRef)(null);
    const listRef = (0, $1oC0p.useRef)(null);
    const [containerWidth, setContainerWidth] = (0, $1oC0p.useState)(0);
    const [measured, setMeasured] = (0, $1oC0p.useState)({
        widths: [],
        gap: 0
    });
    // Mirrors the last overflowsViewport result. Used to add a buffer when
    // switching back from marquee to logos — see the useMemo below.
    const overflowsViewportRef = (0, $1oC0p.useRef)(false);
    // Watch the wrapper div width. We observe the wrapper (not the <ul>) so
    // that applying maxWidth to the <ul> doesn't trigger the observer again.
    (0, $1oC0p.useEffect)(()=>{
        const el = wrapperRef.current;
        if (!el) return;
        const observer = new ResizeObserver(([entry])=>{
            // Ignore zero-width reports — the wrapper can briefly report zero
            // when hidden. Keep the last real width so overflowsViewport stays stable.
            if (entry && entry.contentRect.width > 0) setContainerWidth(entry.contentRect.width);
        });
        observer.observe(el);
        return ()=>observer.disconnect();
    }, []);
    // Measure each logo's natural width and the gap between them.
    // Temporarily removes maxWidth and forces nowrap so all items are on one
    // row, giving accurate individual widths and a correct gap reading.
    (0, $1oC0p.useEffect)(()=>{
        const ul = listRef.current;
        if (!ul) return;
        const measure = ()=>{
            const prevMaxWidth = ul.style.maxWidth;
            const prevMargin = ul.style.margin;
            const prevFlexWrap = ul.style.flexWrap;
            ul.style.maxWidth = "none";
            ul.style.margin = "0";
            // Force all items onto one row so the gap between adjacent items
            // can be measured. The CSS class sets width:100% which overrides
            // width:max-content, so we use flexWrap:nowrap instead.
            ul.style.flexWrap = "nowrap";
            try {
                const items = Array.from(ul.querySelectorAll(":scope > li"));
                const widths = items.map((el)=>el.getBoundingClientRect().width);
                // Skip if all widths are zero — the list is hidden and not giving real values.
                if (widths.length > 0 && widths.every((w)=>w === 0)) return;
                // Detect same-row items by vertical overlap rather than exact
                // top equality — alignItems:center means different-height logos
                // have different top values even when on the same row.
                let gap = 0;
                const r0 = items[0]?.getBoundingClientRect();
                const r1 = items[1]?.getBoundingClientRect();
                if (r0 && r1 && r1.top < r0.bottom && r0.top < r1.bottom) gap = r1.left - r0.right;
                setMeasured({
                    widths: widths,
                    gap: gap
                });
            } finally{
                ul.style.maxWidth = prevMaxWidth;
                ul.style.margin = prevMargin;
                ul.style.flexWrap = prevFlexWrap;
            }
        };
        // Don't re-measure while the marquee is showing — we already know logos
        // overflow, and hidden items can return unreliable widths.
        if (overflowsViewportRef.current) return;
        // Wait for images to load before measuring (they affect logo widths).
        let cancelled = false;
        const images = Array.from(ul.querySelectorAll("img"));
        const unloaded = images.filter((img)=>!img.complete);
        if (unloaded.length === 0) measure();
        else Promise.all(unloaded.map((img)=>new Promise((res)=>img.addEventListener("load", ()=>res(), {
                    once: true
                })))).then(()=>{
            if (!cancelled) measure();
        });
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        logoCount,
        containerWidth
    ]);
    const { maxWidth: maxWidth, overflowsViewport: overflowsViewport } = (0, $1oC0p.useMemo)(()=>{
        const result = (maxWidth, overflowsViewport)=>{
            overflowsViewportRef.current = overflowsViewport;
            return {
                maxWidth: maxWidth,
                overflowsViewport: overflowsViewport
            };
        };
        const { widths: widths, gap: gap } = measured;
        if (!containerWidth || widths.length === 0) return result(undefined, false);
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0) + gap * (widths.length - 1);
        // Everything fits on one row — no constraint needed.
        // Add a one-gap buffer when switching back from marquee to logos to
        // prevent flickering when resizing near the transition point.
        const clearanceNeeded = overflowsViewportRef.current ? gap : 0;
        if (totalWidth <= containerWidth - clearanceNeeded) return result(undefined, false);
        // Greedily split logos into rows given a max row pixel width budget.
        // Returns the pixel width of each row.
        const splitIntoRowWidths = (budget)=>{
            const rowWidths = [];
            let rowWidth = 0;
            for (const w of widths){
                const needed = rowWidth === 0 ? w : gap + w;
                if (rowWidth > 0 && rowWidth + needed > budget) {
                    rowWidths.push(rowWidth);
                    rowWidth = w;
                } else rowWidth += needed;
            }
            rowWidths.push(rowWidth);
            return rowWidths;
        };
        const currentRowWidths = splitIntoRowWidths(containerWidth);
        const numRows = currentRowWidths.length;
        if (numRows <= 1) return result(undefined, true);
        // Score by the minimum row width — maximising it ensures no row is
        // disproportionately short.
        const score = (rowWidths)=>Math.min(...rowWidths);
        // Candidate budgets: pixel width of every possible contiguous subsequence
        // of logos. These are the only meaningful flex-wrap split points.
        const candidateBudgets = new Set();
        for(let start = 0; start < widths.length; start++){
            let rowW = 0;
            for(let end = start; end < widths.length; end++){
                rowW += (widths[end] ?? 0) + (end > start ? gap : 0);
                candidateBudgets.add(rowW);
            }
        }
        let best;
        let bestScore = score(currentRowWidths);
        for (const budget of candidateBudgets){
            if (budget >= containerWidth) continue;
            const rowWidths = splitIntoRowWidths(budget);
            if (rowWidths.length !== numRows) continue;
            const s = score(rowWidths);
            if (s > bestScore) {
                bestScore = s;
                best = `${budget}px`;
            }
        }
        return result(best, true);
    }, [
        measured,
        containerWidth
    ]);
    return {
        maxWidth: maxWidth,
        overflowsViewport: overflowsViewport,
        wrapperRef: wrapperRef,
        listRef: listRef
    };
}
const $511c14fce74817fd$export$c847549a613b9060 = ({ title: title, logos: logos })=>{
    const isWACRefreshGateEnabled = (0, $32ng3.checkFeatureFlagGate)((0, $32ng3.featureFlags).wacRefreshTeam26Gate);
    const checkWacRefreshExperiment = (0, $gIKKj.useExperiment)((0, $areUn.wacRefreshQ4Fy26Experiment));
    const isWacRefresh = isWACRefreshGateEnabled || checkWacRefreshExperiment.type === (0, $gIKKj.EnrollmentType).ENROLLED && checkWacRefreshExperiment.value;
    // Declared here (not inside the isWacRefresh block) so hooks are never called conditionally.
    // Default to true (running); correct to false after mount if the user prefers reduced motion.
    // We do this in useEffect (not useState initializer) to avoid SSR/hydration mismatches,
    // since window.matchMedia is not available on the server.
    const [marqueeRunning, setMarqueeRunning] = (0, $1oC0p.useState)(true);
    (0, $1oC0p.useEffect)(()=>{
        if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) setMarqueeRunning(false);
    }, []);
    const logoColoringStyles = null;
    const { maxWidth: maxWidth, overflowsViewport: overflowsViewport, wrapperRef: wrapperRef, listRef: listRef } = $511c14fce74817fd$var$useBalancedMaxWidth(logos.length);
    const showMarquee = isWacRefresh && overflowsViewport;
    const logosComponent = /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: wrapperRef,
        className: (0, $2jatx.default)([
            "_1bsb1osq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
            ref: listRef,
            style: maxWidth ? {
                maxWidth: maxWidth,
                margin: "0 auto"
            } : undefined,
            className: (0, $2jatx.default)([
                "_1e0c1txw _1n261g80 _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o",
                isWacRefresh && "_gy1p1jfw _4t3i1jfw _99s6oahv _1xlooahv _4jpkxncg _1ikwxncg"
            ]),
            children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                    className: (0, $2jatx.default)([
                        isWacRefresh && "_4t3i1osq _1e0c1txw _4cvr1h6o"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                        src: logo.src,
                        alt: logo.alt,
                        className: (0, $2jatx.default)([
                            "_4t3izwfg _1bsb1wug",
                            "_kdam2v9e _16bu1vqo",
                            isWacRefresh ? "_4t3i1w3c _1bsbkksl" : logo.heightPercentage ? "_4t3in8c9" : logo.width && "_1bsb1y7t _4t3i1wug"
                        ]),
                        style: {
                            "--_y177ig": (0, $6ZVlx.default)(isWacRefresh // css color filter generator for color.neutral.light900
                             ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                            "--_1v9vtiy": (0, $6ZVlx.default)(isWacRefresh ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                            "--_13w6rs2": (0, $6ZVlx.default)(logo.heightPercentage ? `${logo.heightPercentage}%` : "100%"),
                            "--_1l94f44": (0, $6ZVlx.default)(logo.width ? `${logo.width}px` : "auto"),
                            "--_mpa0nt": (0, $6ZVlx.default)(logo.heightPercentage, "%"),
                            "--_daj5q9": (0, $6ZVlx.default)(logo.width, "px")
                        }
                    })
                }, index))
        })
    });
    if (isWacRefresh) {
        const marqueeLogos = [
            ...logos,
            ...logos,
            ...logos,
            ...logos
        ];
        const originalCount = logos.length;
        return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
            className: (0, $2jatx.default)([
                "_kqswh2mm _1rjcxncg"
            ]),
            children: [
                showMarquee ? /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                    className: (0, $2jatx.default)([
                        "_1reo15vq _18m915vq _kqswh2mm _1e0c1txw _2lx21bp4 _zulp1ejb"
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                            className: (0, $2jatx.default)([
                                "_1bsb1osq _p12f1s5k _19pk1wug _2hwx1wug _otyr1wug _18u01wug _1reo15vq"
                            ]),
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _o5721q9c",
                                    "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1txw _1bsb1ns9",
                                    "_gy1p1jfw _4t3i1jfw _99s6oahv _1xlooahv _4jpkxncg _1ikwxncg",
                                    "_y44vhu9l _1y0c12j5"
                                ]),
                                style: {
                                    "--_1xkovpx": (0, $6ZVlx.default)(marqueeRunning ? "running" : "paused")
                                },
                                children: marqueeLogos.map((logo, index)=>{
                                    const isOriginal = index < originalCount;
                                    return /*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                        "aria-hidden": !isOriginal,
                                        className: (0, $2jatx.default)([
                                            "_4t3i1osq _1e0c1txw _4cvr1h6o"
                                        ]),
                                        children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                            src: logo.src,
                                            alt: logo.alt,
                                            className: (0, $2jatx.default)([
                                                "_4t3i1osq _1bsb1ns9 _5ral1f51 _rsuf1h6o",
                                                "_kdam2v9e _16bu1vqo",
                                                logo.heightPercentage && "_4t3in8c9"
                                            ]),
                                            style: {
                                                "--_y177ig": (0, $6ZVlx.default)(isWacRefresh ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                                                "--_1v9vtiy": (0, $6ZVlx.default)(isWacRefresh ? "brightness(0) saturate(100%) invert(20%) sepia(5%) saturate(755%) hue-rotate(185deg) brightness(98%) contrast(86%)" : "grayscale(100%) brightness(66%)"),
                                                "--_mpa0nt": (0, $6ZVlx.default)(logo.heightPercentage, "%")
                                            }
                                        })
                                    }, index);
                                })
                            })
                        }),
                        /*#__PURE__*/ (0, $7VQPk.jsx)((0, $kbpa7.ColumnLayout), {
                            layout: "12",
                            children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                                className: (0, $2jatx.default)([
                                    "_1bsb1osq _1e0c1txw _1bahh9n0"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $jElRc.PlayPauseControls), {
                                    isPlaying: marqueeRunning,
                                    onToggle: ()=>setMarqueeRunning((r)=>!r)
                                })
                            })
                        })
                    ]
                }) : logosComponent,
                showMarquee && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    ref: wrapperRef,
                    "aria-hidden": true,
                    className: (0, $2jatx.default)([
                        "_kqswstnw _152tidpf _1e02idpf _rjxpidpf _3um015vq"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
                        ref: listRef,
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _1n261g80 _1bsb1osq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _1bah1h6o _1p57oahv _gy1pxy5q _99s6xncg _1plrxncg _4cvr1h6o",
                            "_gy1p1jfw _4t3i1jfw _99s6oahv _1xlooahv _4jpkxncg _1ikwxncg"
                        ]),
                        children: logos.map((logo, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)("li", {
                                className: (0, $2jatx.default)([
                                    "_4t3i1osq _1e0c1txw _4cvr1h6o"
                                ]),
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                    src: logo.src,
                                    alt: logo.alt,
                                    className: (0, $2jatx.default)([
                                        "_4t3izwfg _1bsb1wug"
                                    ])
                                })
                            }, index))
                    })
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        className: (0, $2jatx.default)([
            "_1e0c1txw _2lx21bp4 _zulpoahv _pdlmxncg _y3gn1h6o"
        ]),
        children: [
            title && /*#__PURE__*/ (0, $7VQPk.jsx)("h3", {
                className: (0, $2jatx.default)([
                    "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                ]),
                children: title
            }),
            logosComponent
        ]
    });
};
const $511c14fce74817fd$var$regularLogoStyles = null;
// visibility:hidden (not display:none) so ResizeObserver and
// getBoundingClientRect() still return real dimensions.
const $511c14fce74817fd$var$measurementOnlyStyles = null;
const $511c14fce74817fd$var$logosWrapperStyle = null;
const $511c14fce74817fd$var$logosContainerStyle = null;
const $511c14fce74817fd$var$marqueeLogoStyles = null;
const $511c14fce74817fd$var$marqueeListItemStyles = null;
const $511c14fce74817fd$var$listStyles = null;
const $511c14fce74817fd$var$wacRefreshSizeStyles = null;
const $511c14fce74817fd$var$marqueeContainerStyles = null;
const $511c14fce74817fd$var$marqueeListContainerStyles = null;
const $511c14fce74817fd$var$animationKeyframesStyles = null;
const $511c14fce74817fd$var$marqueeControlsContainerStyles = null;

});
parcelRegister("6aliX", function(module, exports) {
$parcel$export(module.exports, "PlayPauseControls", function () { return (parcelRequire("jElRc")).PlayPauseControls; });

var $jElRc = parcelRequire("jElRc");

});


parcelRegister("euqle", function(module, exports) {
$parcel$export(module.exports, "MobileApp", function () { return $dec4263d3b3e8269$export$f81bbe9088ca57b0; });
/* mobile-app.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");
parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $2fk4i = parcelRequire("2fk4i");
const $dec4263d3b3e8269$export$f81bbe9088ca57b0 = ({ title: title, description: description, linkLabel: linkLabel, linkHref: linkHref, linkDataEventProps: linkDataEventProps, imageSrc: imageSrc, imageAlt: imageAlt = "", appleAppStoreUrl: appleAppStoreUrl, googlePlayStoreUrl: googlePlayStoreUrl })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("section", {
        className: (0, $2jatx.default)([
            "_1e0c11p5 _vchhusvi _zulp14hz _1bsb1osq _1dsl1tcg _19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _bozgzwfg _y4tizwfg _qwmh1wqb _yu8o1wqb _1j8bwxkt _1vsw1vi7 _d2ik1wqb _exxm1wqb _10jxzqdx _1pfhxncg"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                className: (0, $2jatx.default)([
                    "_1yd3xy5q _40tuxncg _1mou1wug"
                ]),
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.ContentBlock), {
                        title: title,
                        titleAs: "h2",
                        text: description,
                        callToActionProps: linkLabel && linkHref ? {
                            link: {
                                text: linkLabel,
                                href: linkHref,
                                ...linkDataEventProps && {
                                    dataEventProps: linkDataEventProps
                                }
                            }
                        } : undefined
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _zulppxbi _1pfhxy5q"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: appleAppStoreUrl,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/3g0xj4162q6vj8iis1nr5pkh2scjm13a.png",
                                    alt: "Download on the Apple App Store"
                                })
                            }),
                            /*#__PURE__*/ (0, $7VQPk.jsx)("a", {
                                href: googlePlayStoreUrl,
                                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                                    src: "https://dam-cdn.atl.orangelogic.com/AssetLink/md1w60b88865q56fl84744t5u0heh751.png",
                                    alt: "Get it on the Google Play Store"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_1reo15vq _18m915vq"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                    src: imageSrc,
                    alt: imageAlt,
                    className: (0, $2jatx.default)([
                        "_glte1osq _165t1pna _12rrk5xz _1vkhidpf _1x6l1osq _1bsb1osq _4t3ia91z _5ral1dfr _rsufq0ho"
                    ])
                })
            })
        ]
    });
};
const $dec4263d3b3e8269$var$sectionStyles = null;
const $dec4263d3b3e8269$var$leftSideContentStyles = null;
const $dec4263d3b3e8269$var$appStoreLinksContainerStyles = null;
const $dec4263d3b3e8269$var$imageContainerStyles = null;
const $dec4263d3b3e8269$var$imageStyles = null;

});

parcelRegister("5f18E", function(module, exports) {
$parcel$export(module.exports, "SideNav", function () { return $0ecd955324bfea13$export$1a35787d6353cf6a; });
/* side-nav.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $8e22h = parcelRequire("8e22h");

var $46Ma8 = parcelRequire("46Ma8");

var $bxChG = parcelRequire("bxChG");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
const $0ecd955324bfea13$var$MobileExpandableNav = ({ title: title, children: children })=>{
    const [isExpanded, setIsExpanded] = (0, $1oC0p.useState)(false);
    const [buttonBottom, setButtonBottom] = (0, $1oC0p.useState)(0);
    const navRef = (0, $1oC0p.useRef)(null);
    const buttonRef = (0, $1oC0p.useRef)(null);
    const contentRef = (0, $1oC0p.useRef)(null);
    const handleToggle = ()=>{
        setIsExpanded(!isExpanded);
    };
    // Calculate button position for nav positioning
    (0, $1oC0p.useEffect)(()=>{
        const updateButtonPosition = ()=>{
            if (buttonRef.current) {
                const rect = buttonRef.current.getBoundingClientRect();
                setButtonBottom(rect.bottom);
            }
        };
        updateButtonPosition();
        window.addEventListener("resize", updateButtonPosition);
        window.addEventListener("scroll", updateButtonPosition);
        return ()=>{
            window.removeEventListener("resize", updateButtonPosition);
            window.removeEventListener("scroll", updateButtonPosition);
        };
    }, []);
    // Prevent body scroll when nav is open
    (0, $1oC0p.useEffect)(()=>{
        if (isExpanded) document.body.style.overflow = "hidden";
        else document.body.style.overflow = "unset";
        return ()=>{
            document.body.style.overflow = "unset";
        };
    }, [
        isExpanded
    ]);
    // Handle click outside to close nav
    (0, $1oC0p.useEffect)(()=>{
        const handleClickOutside = (event)=>{
            if (isExpanded && navRef.current && !navRef.current.contains(event.target)) setIsExpanded(false);
        };
        if (isExpanded) document.addEventListener("mousedown", handleClickOutside);
        return ()=>{
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isExpanded
    ]);
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        ref: navRef,
        className: (0, $2jatx.default)([
            "_kqswh2mm"
        ]),
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
                ref: buttonRef,
                onClick: handleToggle,
                "aria-expanded": isExpanded,
                "aria-controls": "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_1bsb1osq _4t3i1wqb _bfhk150w _19itglyw _1yt41hnt _1e0c1txw _4cvr1h6o _zulpu2gc _80omtlke _v564mfn2 _kqswh2mm _1pbyibnn _irr3u4vp _s51sxy5q"
                ]),
                style: {
                    "--_8nj8hf": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light200")),
                    "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: (0, $2jatx.default)([
                            "_4t3i1ejb _1bsb1ejb _1e0c1txw _4cvr1h6o _1bah1h6o _syaz17la"
                        ]),
                        style: {
                            "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue"))
                        },
                        children: isExpanded ? /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bxChG))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $7VQPk.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($46Ma8))), {
                            label: ""
                        })
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)("span", {
                        className: "eyebrow-md",
                        children: title
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                ref: contentRef,
                id: "mobile-side-nav-content",
                className: (0, $2jatx.default)([
                    "_bfhkcd5j _1bsb1osq _18zr1wqb _v564vpel _1reo1wug _18m91wug _s51sxy5q",
                    isExpanded ? "_kqsw1n9t _152t1um1 _dk5didpf _u7coidpf _1bsbauwl _4t3iqi8f _c71lqi8f _tzy4kb7n _1pbyzo7u _1reo15vq _18m915vq _bfhkcd5j _1q51v47k _85i51wqb _18zr1wqb _s51sxy5q" : "_kqsw1n9t _c71lidpf _tzy4idpf _lcxvglyw _152tidpf _dk5didpf _1bsbauwl"
                ]),
                style: {
                    "--_7zbnls": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light0")),
                    "--_ab93rs": (0, $6ZVlx.default)(buttonBottom, "px")
                },
                children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        "_4t3i1osq _1reo1wug _18m91wug"
                    ]),
                    children: children
                })
            })
        ]
    });
};
const $0ecd955324bfea13$export$6b43f262d1299a2e = ({ sideNavItems: sideNavItems })=>{
    return /*#__PURE__*/ (0, $7VQPk.jsx)("ul", {
        className: (0, $2jatx.default)([
            "_qtt8glyw _18s8ze3t _1yt4ze3t _1reo1wug _18m91wug _1jc21nkh _1xey1k0a",
            "sidenav-menu"
        ]),
        style: {
            "--_1lmj1bv": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light300"))
        },
        children: sideNavItems.map((sideNavItem)=>{
            if (sideNavItem.type === "collection") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.SideNavCollection), {
                type: "collection",
                collectionName: sideNavItem.collectionName,
                sideNavItems: sideNavItem.sideNavItems,
                depth: 0
            }, sideNavItem.collectionName);
            if (sideNavItem.type === "link") return /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.SideNavLink), {
                dataEventProps: sideNavItem.dataEventProps,
                type: "link",
                text: sideNavItem.text,
                href: sideNavItem.href,
                anchors: sideNavItem.anchors,
                depth: 0
            }, sideNavItem.text);
            return null;
        })
    });
};
const $0ecd955324bfea13$export$1a35787d6353cf6a = ({ title: title, sideNavItems: sideNavItems })=>{
    const intl = (0, $8e22h.default)();
    return /*#__PURE__*/ (0, $7VQPk.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7VQPk.jsxs)("nav", {
                id: "side-nav-desktop",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.desktop.label",
                    defaultMessage: `{hub_topics} desktop navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_1mjbglyw",
                    "_kqsw1if8 _152t1dln",
                    "_19ityzqy _2rkovwyg _1yt4v47k _85i51wqb _4t3i1ns9"
                ]),
                style: {
                    "--_r91gx3": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.neutral.light400")),
                    "--_19sjjnh": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.card"))
                },
                children: [
                    /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                        className: (0, $2jatx.default)([
                            "_1e0c1txw _4cvr1h6o _1tke1wqb _1yt41dg4",
                            "eyebrow-md"
                        ]),
                        children: title
                    }),
                    /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("nav", {
                id: "side-nav-tablet-mobile",
                "aria-label": intl.formatMessage({
                    id: "hub.sidenav.mobile.label",
                    defaultMessage: `{hub_topics} mobile navigation`
                }, {
                    hub_topics: title
                }),
                className: (0, $2jatx.default)([
                    "_dm25glyw",
                    "_kqsw1n9t _1e02idpf _1pbyegat _1bsbauwl"
                ]),
                children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$var$MobileExpandableNav, {
                    title: title,
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)($0ecd955324bfea13$export$6b43f262d1299a2e, {
                        sideNavItems: sideNavItems
                    })
                })
            }),
            /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                className: (0, $2jatx.default)([
                    "_dm25glyw",
                    "_4t3i1wqb"
                ])
            })
        ]
    });
};
const $0ecd955324bfea13$var$desktopCss = null;
const $0ecd955324bfea13$var$tabletMobileCss = null;
const $0ecd955324bfea13$var$stickyCss = null;
const $0ecd955324bfea13$var$fixedCss = null;
const $0ecd955324bfea13$var$listCss = null;
const $0ecd955324bfea13$var$containerCss = null;
const $0ecd955324bfea13$var$desktopTitleCss = null;
const $0ecd955324bfea13$var$mobileIconCss = null;
const $0ecd955324bfea13$var$mobileExpandableButtonCss = null;
const $0ecd955324bfea13$var$mobileNavContentCss = null;
const $0ecd955324bfea13$var$mobileNavContentCollapsedCss = null;
const $0ecd955324bfea13$var$mobileInnerContentCss = null;

});
parcelRegister("bxChG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3e2df2c0b677df1945f42cd8e58b7f64>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8670793cd6a627cd$var$_react = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $8670793cd6a627cd$var$_baseNew = $8670793cd6a627cd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $8670793cd6a627cd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Minus".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: horizontal rule in Editor.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8670793cd6a627cd$var$MinusIcon = (props)=>/*#__PURE__*/ $8670793cd6a627cd$var$_react.default.createElement($8670793cd6a627cd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 8.75H1v-1.5h14z" clip-rule="evenodd"/>`
    }, props));
$8670793cd6a627cd$var$MinusIcon.displayName = 'MinusIcon';
var $8670793cd6a627cd$var$_default = module.exports.default = $8670793cd6a627cd$var$MinusIcon;

});


parcelRegister("5uGt2", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return (parcelRequire("aeZV4")).useTabsContext; });
$parcel$export(module.exports, "Tabs", function () { return (parcelRequire("aeZV4")).Tabs; });
$parcel$export(module.exports, "DraggableTabList", function () { return (parcelRequire("6Iidb")).DraggableTabList; });
$parcel$export(module.exports, "DraggableTab", function () { return (parcelRequire("4q5Ua")).DraggableTab; });
$parcel$export(module.exports, "TabPanel", function () { return (parcelRequire("kFhJA")).TabPanel; });
$parcel$export(module.exports, "TabsSection", function () { return (parcelRequire("7kpd6")).TabsSection; });
$parcel$export(module.exports, "mapChild", function () { return (parcelRequire("jgQie")).mapChild; });

var $aeZV4 = parcelRequire("aeZV4");

var $6Iidb = parcelRequire("6Iidb");

var $4q5Ua = parcelRequire("4q5Ua");

var $kFhJA = parcelRequire("kFhJA");

var $7kpd6 = parcelRequire("7kpd6");

var $jgQie = parcelRequire("jgQie");

});
parcelRegister("aeZV4", function(module, exports) {
$parcel$export(module.exports, "useTabsContext", function () { return $0f3c3abb0b914582$export$5c3d36c3adf0ba92; });
$parcel$export(module.exports, "Tabs", function () { return $0f3c3abb0b914582$export$b2539bed5023c21c; });
/* tabs.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $jKShK = parcelRequire("jKShK");

var $aHkxS = parcelRequire("aHkxS");

var $jgQie = parcelRequire("jgQie");
const $0f3c3abb0b914582$var$TabsContext = /*#__PURE__*/ (0, $1oC0p.createContext)(null);
const $0f3c3abb0b914582$export$5c3d36c3adf0ba92 = ()=>{
    const context = (0, $1oC0p.useContext)($0f3c3abb0b914582$var$TabsContext);
    if (!context) throw new Error("useTabsContext must be used within Tabs");
    return context;
};
let $0f3c3abb0b914582$var$nextId = 0;
function $0f3c3abb0b914582$var$getTabIndexFromUrl(tabIds) {
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    const tabParam = params.get("tab");
    if (!tabParam) return null;
    const index = tabIds.indexOf(tabParam);
    return index !== -1 ? index : null;
}
const $0f3c3abb0b914582$export$b2539bed5023c21c = ({ id: id, initialTab: initialTab, loop: loop = true, tabIds: externalTabIds, children: children, useInViewOptionsContainer: useInViewOptionsContainer })=>{
    const resolvedInitialTab = (()=>{
        if (externalTabIds && externalTabIds.length > 0) {
            const urlIndex = $0f3c3abb0b914582$var$getTabIndexFromUrl(externalTabIds);
            if (urlIndex !== null) return urlIndex;
        }
        return initialTab ?? 0;
    })();
    const [currentTab, setCurrentTab] = (0, $1oC0p.useState)(resolvedInitialTab);
    const [userSelected, setUserSelected] = (0, $1oC0p.useState)(false);
    const [focus, setFocus] = (0, $1oC0p.useState)(false);
    const tabIds = (0, $1oC0p.useRef)([]);
    const contextId = (0, $1oC0p.useRef)(`:tabs:${id ? id : $0f3c3abb0b914582$var$nextId++}:`);
    const DEFAULT_IN_VIEW_THRESHOLD = 0.3;
    const { ref: containerScrollRef, inView: tabsContainerIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD,
        ...useInViewOptionsContainer
    });
    const { ref: tabListScrollRef, inView: tabListIsVisible } = (0, $jKShK.useInView)({
        threshold: DEFAULT_IN_VIEW_THRESHOLD
    });
    function getTabsCount() {
        let count = 0;
        (0, $jgQie.deepForEach)(children, (child)=>{
            if ((0, $jgQie.isTab)(child)) count++;
        });
        return count;
    }
    function getChildren() {
        const tabsCount = getTabsCount();
        let panelIndex = 0;
        tabIds.current = tabIds.current || [];
        let diff = tabIds.current.length - tabsCount;
        // Add ids if new tabs have been added
        // Don't bother removing ids, just keep them in case they are added again
        // This is more efficient, and keeps the uuid counter under control
        while(diff++ < 0)tabIds.current.push(`${contextId.current}${tabIds.current.length}`);
        // Map children to dynamically setup refs
        return (0, $jgQie.deepMap)(children, (child)=>{
            let result = child;
            // Check if the window is available
            const windowAvailable = !!window && !!window.document && !!window.document.activeElement;
            // Get the active element id
            const activeElementId = windowAvailable ? window.document.activeElement?.id : null;
            // Clone TabList and Tab components to have refs
            if ((0, $jgQie.isTabList)(child)) {
                let listIndex = 0;
                // Figure out if the current focus in the DOM is set on a Tab
                // If it is we should keep the focus on the next selected tab
                let wasTabFocus = false;
                if (windowAvailable && activeElementId) // Check if the active element is a tab
                wasTabFocus = (0, $1oC0p.Children).toArray(child.props.children).filter((0, $jgQie.isTab)).some((_, i)=>{
                    return activeElementId === `tab${tabIds.current[i]}`;
                });
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, {
                    children: (0, $jgQie.deepMap)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
                    child.props.children, (tab)=>{
                        const selected = currentTab === listIndex;
                        const props = {
                            id: tabIds.current[listIndex],
                            tabIndex: listIndex,
                            focus: selected && (focus || wasTabFocus)
                        };
                        listIndex++;
                        return /*#__PURE__*/ (0, $1oC0p.cloneElement)(tab, props);
                    })
                });
            } else if ((0, $jgQie.isTabPanel)(child)) {
                // Preserve existing props (like hideTabPanelRole) when cloning
                const existingProps = child.props || {};
                const props = {
                    ...existingProps,
                    id: tabIds.current[panelIndex],
                    panelIndex: panelIndex
                };
                panelIndex++;
                result = /*#__PURE__*/ (0, $1oC0p.cloneElement)(child, props);
            }
            return result;
        });
    }
    const unsetUserSelected = ()=>{
        setUserSelected(false);
    };
    const goToTab = (tabIndex)=>{
        if (tabIndex === undefined) return;
        setCurrentTab(tabIndex);
        setUserSelected(true);
        if (externalTabIds && externalTabIds.length > tabIndex && typeof window !== "undefined") {
            const params = new URLSearchParams(window.location.search);
            params.set("tab", externalTabIds[tabIndex]);
            const newUrl = `${window.location.pathname}?${params.toString()}${window.location.hash}`;
            window.history.replaceState(null, "", newUrl);
        }
    };
    const isCurrentTab = (tabIndex)=>{
        return tabIndex === currentTab;
    };
    const goToNextTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab + 1 < tabIds.current.length) goToTab(currentTab + 1);
        else if (loop) goToTab(0);
    }, [
        loop,
        currentTab
    ]);
    const goToPrevTab = (0, $1oC0p.useCallback)(()=>{
        if (currentTab - 1 >= 0) goToTab(currentTab - 1);
        else if (loop) goToTab(tabIds.current.length - 1);
    }, [
        loop,
        currentTab
    ]);
    const goToFirstTab = ()=>{
        goToTab(0);
    };
    const goToLastTab = ()=>{
        goToTab(tabIds.current.length - 1);
    };
    const onKeyDown = (e)=>{
        if (e.code === "ArrowLeft" || e.code === "ArrowUp") goToPrevTab();
        else if (e.code === "ArrowRight" || e.code === "ArrowDown") goToNextTab();
        else if (e.code === "End") // Select last tab (End key)
        goToFirstTab();
        else if (e.code === "Home") // Select first tab (Home key)
        goToLastTab();
        else return;
        setUserSelected(true);
        setFocus(true);
        // This prevents scrollbars from moving around
        e.preventDefault();
    };
    // Reset the userSelected state when the section is visible again
    (0, $1oC0p.useEffect)(()=>{
        if (tabsContainerIsVisible) setUserSelected(false);
    }, [
        tabsContainerIsVisible
    ]);
    // Reinitialize analytics when the tab changes
    // this is needed because the content wasn't rendered before
    (0, $1oC0p.useEffect)(()=>{
        (0, $aHkxS.Initializer).autoTrack();
    }, [
        currentTab
    ]);
    const containerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)($0f3c3abb0b914582$var$TabsContext.Provider, {
        value: {
            currentTab: currentTab,
            userSelected: userSelected,
            unsetUserSelected: unsetUserSelected,
            goToTab: goToTab,
            isCurrentTab: isCurrentTab,
            goToNextTab: goToNextTab,
            goToPrevTab: goToPrevTab,
            goToFirstTab: goToFirstTab,
            goToLastTab: goToLastTab,
            onKeyDown: onKeyDown,
            tabsContainerIsVisible: tabsContainerIsVisible,
            tabListIsVisible: tabListIsVisible,
            tabListScrollRef: tabListScrollRef
        },
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            ref: containerScrollRef,
            className: (0, $2jatx.default)([
                "_1e0c1txw _2lx21bp4 _zulp1jfw _1reo15vq _18m915vq"
            ]),
            children: getChildren()
        })
    });
};

});
parcelRegister("jgQie", function(module, exports) {
$parcel$export(module.exports, "isTab", function () { return $5fe887815c1bacdb$export$bdc9792d96913679; });
$parcel$export(module.exports, "isTabList", function () { return $5fe887815c1bacdb$export$9c326233b9ae5588; });
$parcel$export(module.exports, "isTabPanel", function () { return $5fe887815c1bacdb$export$9e12445c79db89b; });
$parcel$export(module.exports, "mapChild", function () { return $5fe887815c1bacdb$export$886f34b49305b07b; });
$parcel$export(module.exports, "deepMap", function () { return $5fe887815c1bacdb$export$ce7eaaed37329a1b; });
$parcel$export(module.exports, "deepForEach", function () { return $5fe887815c1bacdb$export$519ada94592b97fc; });

var $1oC0p = parcelRequire("1oC0p");
function $5fe887815c1bacdb$var$makeTypeChecker(tabsRole) {
    return (element)=>!!element.type && element.type.tabsRole === tabsRole;
}
const $5fe887815c1bacdb$export$bdc9792d96913679 = $5fe887815c1bacdb$var$makeTypeChecker("Tab");
const $5fe887815c1bacdb$export$9c326233b9ae5588 = $5fe887815c1bacdb$var$makeTypeChecker("TabList");
const $5fe887815c1bacdb$export$9e12445c79db89b = $5fe887815c1bacdb$var$makeTypeChecker("TabPanel");
const $5fe887815c1bacdb$export$dbaa4172856e20ab = (element)=>!!element.type && typeof element.type === "function";
function $5fe887815c1bacdb$var$isTabChild(child) {
    return $5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9c326233b9ae5588(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child);
}
function $5fe887815c1bacdb$export$886f34b49305b07b(child, additionalProps) {
    if (child === null) return null;
    // Only pass additionalProps to functional components
    // React.cloneElement will throw an error if you pass additionalProps to a dom component like div
    if ($5fe887815c1bacdb$export$dbaa4172856e20ab(child)) return (0, $1oC0p.cloneElement)(child, {
        ...child.props,
        ...additionalProps
    });
    return child;
}
function $5fe887815c1bacdb$export$ce7eaaed37329a1b(children, callback) {
    return (0, $1oC0p.Children).map(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return null;
        if ($5fe887815c1bacdb$var$isTabChild(child)) return callback(child, index);
        if (child && child.props && child.props.children && typeof child.props.children === "object") // Clone the child that has children and map them too
        return (0, $1oC0p.cloneElement)(child, {
            ...child.props,
            children: $5fe887815c1bacdb$export$ce7eaaed37329a1b(child.props.children, callback)
        });
        return child;
    });
}
function $5fe887815c1bacdb$export$519ada94592b97fc(children, callback) {
    return (0, $1oC0p.Children).forEach(children, (child, index)=>{
        // null happens when conditionally rendering TabPanel/Tab
        if (child === null) return;
        if ($5fe887815c1bacdb$export$bdc9792d96913679(child) || $5fe887815c1bacdb$export$9e12445c79db89b(child)) callback(child, index);
        else if (child && child.props && child.props.children && typeof child.props.children === "object") {
            if ($5fe887815c1bacdb$export$9c326233b9ae5588(child)) callback(child, index);
            $5fe887815c1bacdb$export$519ada94592b97fc(child.props.children, callback);
        }
    });
}

});


parcelRegister("6Iidb", function(module, exports) {
$parcel$export(module.exports, "DraggableTabList", function () { return $5334c6b54e489af6$export$dbb4ac5a817c6612; });
/* draggable-tab-list.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $5334c6b54e489af6$export$dbb4ac5a817c6612 = ({ alignment: alignment = "start", tabSize: // @ts-ignore
tabSize = "large", children: children })=>{
    const containerRef = (0, $1oC0p.useRef)(null);
    const mouseDown = (0, $1oC0p.useRef)(false);
    const startX = (0, $1oC0p.useRef)(0);
    const scrollLeft = (0, $1oC0p.useRef)(0);
    const canDrag = (0, $1oC0p.useRef)(false);
    const { onKeyDown: onKeyDown } = (0, $aeZV4.useTabsContext)();
    const startDragging = (mouse, touch)=>{
        if (!canDrag.current) return;
        // Start listening for mouseup and mousemove events outside of the tab list
        document.addEventListener("mouseup", stopDragging);
        document.addEventListener("mousemove", move);
        mouseDown.current = true;
        startX.current = (touch && touch.touches[0] ? touch.touches[0].clientX : mouse?.clientX) ?? 0;
        scrollLeft.current = containerRef.current?.scrollLeft ?? 0;
    };
    const stopDragging = ()=>{
        if (!canDrag.current) return;
        // Stop listening for mouseup and mousemove events
        document.removeEventListener("mouseup", stopDragging);
        document.removeEventListener("mousemove", move);
        mouseDown.current = false;
    };
    const move = (mouse, touch)=>{
        if (!canDrag.current || !mouseDown.current || !containerRef.current) return;
        let dragAmount = 0;
        if (touch && touch.changedTouches[0]) dragAmount = touch.changedTouches[0].clientX - startX.current;
        else if (mouse) dragAmount = mouse.clientX - startX.current;
        containerRef.current.scrollLeft = scrollLeft.current - dragAmount;
    };
    (0, $1oC0p.useEffect)(()=>{
        const updateCanDrag = ()=>{
            if (containerRef.current) {
                const container = containerRef.current;
                canDrag.current = container.scrollWidth > container.clientWidth;
            }
        };
        const setStartingPoint = ()=>{
            if (containerRef.current) {
                if (canDrag.current) {
                    const tabPanels = document.querySelector(".tab-panels");
                    const tabPanelsStyle = tabPanels && window.getComputedStyle(tabPanels);
                    containerRef.current.setAttribute("style", `padding-left: calc(${tabPanelsStyle?.marginLeft} + ${tabPanelsStyle?.paddingLeft});`);
                } else if (alignment === "start") containerRef.current.setAttribute("style", "margin-inline: 0px; padding-inline: 0px;");
            }
        };
        if (!containerRef.current) return;
        const observer = new ResizeObserver(()=>{
            updateCanDrag();
            setStartingPoint();
        });
        observer.observe(containerRef.current);
        return ()=>{
            observer.disconnect();
        };
    });
    const wrapperStyle = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ref: containerRef,
        className: (0, $2jatx.default)([
            "_1reo15vq _p12f1osq _195g1wug _18zrzwfg _11q81vi7 _su071wqb _3hzp1wqb"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
            // @ts-ignore
            onTouchStart: (e)=>startDragging(undefined, e),
            // @ts-ignore
            onMouseDown: (e)=>startDragging(e),
            // @ts-ignore
            onTouchEnd: (e)=>{
                // @ts-ignore
                move(undefined, e);
                stopDragging();
            },
            // @ts-ignore
            onTouchMove: (e)=>move(undefined, e),
            onKeyDown: onKeyDown,
            className: (0, $2jatx.default)([
                "_1e0c1txw _4cvr1y6m _1bah1y6m _1n261q9c _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _qtt8glyw _1bsb1ns9 _p12f1osq _1moupxbi _zulp1ejb",
                "tab-list"
            ]),
            tabIndex: -1,
            role: "tablist",
            children: children
        })
    });
};
const $5334c6b54e489af6$var$tabsContainerStyles = null;
$5334c6b54e489af6$export$dbb4ac5a817c6612.tabsRole = "TabList";

});

parcelRegister("4q5Ua", function(module, exports) {
$parcel$export(module.exports, "DraggableTab", function () { return $2726a747230786c6$export$3a29ca89d63c5c20; });
/* draggable-tab.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");
var $6ZVlx = parcelRequire("6ZVlx");

var $2fk4i = parcelRequire("2fk4i");

var $kbpa7 = parcelRequire("kbpa7");
parcelRequire("5uGt2");
var $aeZV4 = parcelRequire("aeZV4");
const $2726a747230786c6$export$3a29ca89d63c5c20 = ({ id: id, focus: focus, tabIndex: tabIndex, title: title, iconUrl: iconUrl, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", label: label, dataEventProps: dataEventProps, className: className, enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false, children: children, ...props })=>{
    const { goToTab: goToTab, isCurrentTab: isCurrentTab, userSelected: userSelected } = (0, $aeZV4.useTabsContext)();
    const startX = (0, $1oC0p.useRef)(0);
    const tabRef = /*#__PURE__*/ (0, $1oC0p.createRef)();
    const isTabSelected = isCurrentTab(tabIndex);
    (0, $1oC0p.useEffect)(()=>{
        if (!tabRef.current || !tabRef.current.parentElement || !tabRef.current.parentElement.scrollTo || !tabRef.current.parentElement.parentElement || !tabRef.current.parentElement.parentElement.scrollTo) return;
        // Scroll to the selected tab if it's not in view
        if (isTabSelected) {
            if (tabRef.current.parentElement?.parentElement) {
                // calculate the offset to center the tab in the parent
                const offsetLeft = tabRef.current.offsetLeft - tabRef.current.parentElement.offsetLeft - tabRef.current.parentElement.offsetWidth / 2 + tabRef.current.offsetWidth / 2;
                tabRef.current.parentElement.parentElement.scrollTo({
                    left: offsetLeft,
                    top: 0,
                    behavior: "smooth"
                });
            }
            if (focus) tabRef.current.focus({
                preventScroll: true
            });
        }
        if (isTabSelected && dataEventProps && userSelected) tabRef.current.dispatchEvent(new Event("select"));
    }, [
        tabRef,
        isTabSelected,
        focus,
        userSelected,
        dataEventProps
    ]);
    const onMouseDown = (e)=>{
        startX.current = e.clientX ?? 0;
        props.onMouseDown?.(e);
    };
    const onClick = (0, $1oC0p.useCallback)((e)=>{
        if (Math.abs(e.clientX - startX.current) > 15) // Prevent click event if user is dragging
        return;
        props.onClick?.(e);
        if (isTabSelected) return;
        goToTab(tabIndex);
    }, [
        isTabSelected,
        tabIndex,
        goToTab,
        props
    ]);
    const onKeyDown = (e)=>{
        if (e.code === "Space" || e.code === "Enter") {
            goToTab(tabIndex);
            e.preventDefault();
        }
    };
    const tabColor = bgColor === "bgWhite" ? (0, $kbpa7.wacToken)("color.neutral.light200") : (0, $kbpa7.wacToken)("color.neutral.light0");
    const tabStyles = null;
    const rovoBorderStyles = null;
    const borderStyles = null;
    const largeTabStyles = null;
    const smallTabStyles = null;
    const iconTabStyles = null;
    const iconLargeTabStyles = null;
    const iconSmallTabStyles = null;
    const responsiveIconTabStyles = null;
    const iconLargeContainerStyles = null;
    const iconSmallContainerStyles = null;
    const responsiveIconContainerStyles = null;
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...props,
        // @ts-ignore
        ref: tabRef,
        // @ts-ignore
        className: className,
        children: !!children ? /*#__PURE__*/ (0, $1oC0p.cloneElement)(children, {
            onMouseDown: // @ts-ignore
            onMouseDown,
            onClick: // @ts-ignore
            onClick,
            onKeyDown: // @ts-ignore
            onKeyDown,
            ...dataEventProps
        }) : /*#__PURE__*/ (0, $7VQPk.jsxs)("button", {
            id: `tab${id}`,
            role: "tab",
            "aria-selected": isTabSelected,
            "aria-controls": `panel${id}`,
            "aria-label": label,
            title: label,
            className: (0, $2jatx.default)([
                "_o5721q9c _1ul9ymf6 _bfhk1jrh _4cvr1h6o _1bah1h6o _vchhusvi _1e0c1txw _y3gn1h6o _4bfu1r31 _1hmsglyw _ajmmnqa1 _2rko17td _19itq75r _80omtlke _4cvx17la _8y9r1hlo",
                iconUrl && "_2lx21bp4 _2rkoi2wt _1wyb1j6v",
                iconUrl && enableRovoBorder ? "_1h6d1j28 _1s79mzrp _1esp1ws1 _494pusvi _iusibx47" : "_1npj1ybm _1s7917la",
                iconUrl && enableResponsiveTabSize && "_4t3i1n2x _1ul9176v _1yt437zh _1xlocmky _1d2y11ux _6ytt139i",
                !iconUrl && tabSize === "large" && "_ca0qdlk8 _u5f31f4h _n3tddlk8 _19bv1f4h _vwz41f4h _4t3i1wqb _1wyb1cby",
                !iconUrl && tabSize === "small" && "_1yt41c98 _vwz4v47k _4t3i1ylp _1wyb1j6v",
                iconUrl && !enableResponsiveTabSize && tabSize === "large" && "_4t3icmky _1ul911ux _1yt4139i",
                iconUrl && !enableResponsiveTabSize && tabSize === "small" && "_4t3i1n2x _1ul9176v _1yt437zh",
                `${isTabSelected ? "currentTab" : ""}`
            ]),
            // how to adjust for different page? or just remove?
            "data-product-key": "template",
            "data-event": "clicked",
            "data-event-component": "button",
            "data-event-container": "tabsMenu",
            "data-label": title,
            // @ts-ignore
            onMouseDown: onMouseDown,
            // @ts-ignore
            onClick: onClick,
            // @ts-ignore
            onKeyDown: onKeyDown,
            ...dataEventProps,
            style: {
                "--_7aj7gm": (0, $6ZVlx.default)(tabColor),
                "--_514je1": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("corner.radius.pill")),
                "--_1r6llbg": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.blue")),
                "--_188070z": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.primary.black")),
                "--_1hkddbi": (0, $6ZVlx.default)((0, $kbpa7.wacToken)("color.extended.blue100"))
            },
            children: [
                iconUrl && /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        !enableResponsiveTabSize && tabSize === "large" && "_4t3ickbl _1bsbckbl",
                        !enableResponsiveTabSize && tabSize === "small" && "_4t3i10mc _1bsb10mc",
                        enableResponsiveTabSize && "_4t3i10mc _1bsb10mc _1xlockbl _14b5ckbl",
                        "default-icon"
                    ]),
                    children: /*#__PURE__*/ (0, $7VQPk.jsx)((0, $2fk4i.Image), {
                        src: `${iconUrl || ""}`,
                        alt: "",
                        draggable: false
                    })
                }),
                title
            ]
        })
    });
};
$2726a747230786c6$export$3a29ca89d63c5c20.tabsRole = "Tab";

});

parcelRegister("kFhJA", function(module, exports) {
$parcel$export(module.exports, "TabPanel", function () { return $73f95d72bd57759d$export$3d96ec278d3efce4; });
/* tab-panel.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $1oC0p = parcelRequire("1oC0p");

var $2jatx = parcelRequire("2jatx");

var $lTkkF = parcelRequire("lTkkF");
parcelRequire("5uGt2");
var $jgQie = parcelRequire("jgQie");
var $aeZV4 = parcelRequire("aeZV4");
const $73f95d72bd57759d$var$hidePanelStyle = null;
const $73f95d72bd57759d$export$3d96ec278d3efce4 = ({ forceRender: forceRender, children: children, panelIndex: panelIndex, id: id, hideTabPanelRole: hideTabPanelRole, ...props })=>{
    const { isCurrentTab: isCurrentTab } = (0, $aeZV4.useTabsContext)();
    const isTabSelected = isCurrentTab(panelIndex);
    const activeClass = isTabSelected ? "active-panel" : "";
    const { panelId: panelId, tabId: tabId } = (0, $lTkkF.generateSafeIds)(id, panelIndex);
    const originalChildrenCount = (0, $1oC0p.Children).count(children);
    const shouldHideRole = hideTabPanelRole !== undefined ? hideTabPanelRole : originalChildrenCount === 0;
    const { css: existingCss, ...propsWithoutCss } = props;
    const filteredProps = Object.fromEntries(Object.entries(propsWithoutCss).filter(([key])=>!key.startsWith("aria-") && key !== "role"));
    const inlineHideStyle = !isTabSelected && !forceRender ? {
        display: "none"
    } : undefined;
    if (!shouldHideRole) return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        ...filteredProps,
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        "aria-labelledby": tabId,
        "aria-hidden": !isTabSelected,
        role: "tabpanel",
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
    return /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
        style: inlineHideStyle,
        id: panelId,
        "data-testid": panelId,
        className: (0, $2jatx.default)([
            !isTabSelected && !forceRender && "_1e0cglyw",
            [
                "tab-panel",
                activeClass
            ].join(" ")
        ]),
        "aria-labelledby": undefined,
        "aria-hidden": undefined,
        role: undefined,
        children: (0, $1oC0p.Children).map(children, (child)=>{
            return (0, $jgQie.mapChild)(child, {
                isPanelActive: isTabSelected
            });
        })
    });
};
$73f95d72bd57759d$export$3d96ec278d3efce4.tabsRole = "TabPanel";

});

parcelRegister("7kpd6", function(module, exports) {
$parcel$export(module.exports, "TabsSection", function () { return $55e394e1b826b27b$export$502de1d4d55224c1; });
/* tabs-section.tsx generated by @compiled/babel-plugin v0.28.8 */ 
var $7VQPk = parcelRequire("7VQPk");

var $2jatx = parcelRequire("2jatx");
parcelRequire("1oC0p");
parcelRequire("5uGt2");
var $4q5Ua = parcelRequire("4q5Ua");
var $6Iidb = parcelRequire("6Iidb");
var $kFhJA = parcelRequire("kFhJA");
var $aeZV4 = parcelRequire("aeZV4");
const $55e394e1b826b27b$export$502de1d4d55224c1 = ({ alignment: alignment = "start", tabsData: tabsData, tabSize: tabSize = "large", bgColor: bgColor = "bgWhite", enableRovoBorder: enableRovoBorder = false, enableResponsiveTabSize: enableResponsiveTabSize = false })=>{
    const sectionStyles = null;
    const fullWidthContainerStyles = null;
    const enableIconTabs = tabsData.every((tab)=>tab.iconUrl);
    return /*#__PURE__*/ (0, $7VQPk.jsx)("section", {
        id: "tabs",
        className: (0, $2jatx.default)([
            "_1bsb1osq _1reo15vq _18m915vq"
        ]),
        children: /*#__PURE__*/ (0, $7VQPk.jsxs)((0, $aeZV4.Tabs), {
            tabIds: tabsData.map((tab)=>tab.id),
            children: [
                /*#__PURE__*/ (0, $7VQPk.jsx)((0, $6Iidb.DraggableTabList), {
                    tabSize: tabSize,
                    alignment: alignment,
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $4q5Ua.DraggableTab), {
                            tabIndex: index,
                            title: tab.title,
                            iconUrl: enableIconTabs ? tab.iconUrl : undefined,
                            tabSize: tabSize,
                            bgColor: bgColor,
                            className: "round-tab",
                            enableRovoBorder: enableIconTabs && enableRovoBorder,
                            enableResponsiveTabSize: enableIconTabs && enableResponsiveTabSize
                        }, index))
                }),
                /*#__PURE__*/ (0, $7VQPk.jsx)("div", {
                    className: (0, $2jatx.default)([
                        tabSize === "large" && "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _p12f1osq _vchhusvi _1reoewfl _18m9ewfl _bozgzwfg _y4tizwfg _1bsb1osq _qwmh1wqb _yu8o1wqb _d2ik1wqb _exxm1wqb _10jxzqdx",
                        "tab-panels"
                    ]),
                    children: tabsData.map((tab, index)=>/*#__PURE__*/ (0, $7VQPk.jsx)((0, $kFhJA.TabPanel), {
                            panelIndex: index,
                            id: tab.id || `tab-${index}`,
                            children: tab.tabComponent
                        }, index))
                })
            ]
        })
    });
};

});



parcelRegister("hXSMk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::76f067d08aa7c324d1505318ade2e26f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d14270378c3131a7$var$_react = $d14270378c3131a7$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $d14270378c3131a7$var$_baseNew = $d14270378c3131a7$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $d14270378c3131a7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Alert".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for alerts in JSM and Compass.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d14270378c3131a7$var$AlertIcon = (props)=>/*#__PURE__*/ $d14270378c3131a7$var$_react.default.createElement($d14270378c3131a7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.75 0v3h-1.5V0zM2.123 1.063 4.172 3.11 3.11 4.17 1.063 2.124zm12.814 1.06L12.89 4.172 11.83 3.11l2.047-2.048zM4.195 5.875A1.5 1.5 0 0 1 5.69 4.5h4.62a1.5 1.5 0 0 1 1.495 1.375l.635 7.625H14V15H2v-1.5h1.56zm.87 7.625h5.87L10.31 6H5.69z" clip-rule="evenodd"/>`
    }, props));
$d14270378c3131a7$var$AlertIcon.displayName = 'AlertIcon';
var $d14270378c3131a7$var$_default = module.exports.default = $d14270378c3131a7$var$AlertIcon;

});

parcelRegister("eOOWL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::54f75e2054943fb775b789c9f2b57e27>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ac9d412ae10a01ab$var$_react = $ac9d412ae10a01ab$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ac9d412ae10a01ab$var$_baseNew = $ac9d412ae10a01ab$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ac9d412ae10a01ab$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bar charts; Reports in JSM, Space Analytics in Confluence
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ac9d412ae10a01ab$var$ChartBarIcon = (props)=>/*#__PURE__*/ $ac9d412ae10a01ab$var$_react.default.createElement($ac9d412ae10a01ab$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="m5.25 8.5.077.004A.75.75 0 0 1 6 9.25v2.5a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-2.5a.75.75 0 0 1 .75-.75zm4-3.5a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 8.25 5zm4-3a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-.75.75h-1a.75.75 0 0 1-.75-.75v-9a.75.75 0 0 1 .75-.75z"/>`
    }, props));
$ac9d412ae10a01ab$var$ChartBarIcon.displayName = 'ChartBarIcon';
var $ac9d412ae10a01ab$var$_default = module.exports.default = $ac9d412ae10a01ab$var$ChartBarIcon;

});

parcelRegister("kzcfD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::de887aadbfedd5e674ee79e9bf8242ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef90945cc818a91e$var$_react = $ef90945cc818a91e$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $ef90945cc818a91e$var$_baseNew = $ef90945cc818a91e$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $ef90945cc818a91e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LobbyBell".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: risks in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef90945cc818a91e$var$LobbyBellIcon = (props)=>/*#__PURE__*/ $ef90945cc818a91e$var$_react.default.createElement($ef90945cc818a91e$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1h4v1.5H8.75v1.75h.92a4.75 4.75 0 0 1 4.72 4.225l.355 3.192A.75.75 0 0 1 14 12.5H2a.75.75 0 0 1-.745-.833l.354-3.192A4.75 4.75 0 0 1 6.33 4.25h.92V2.5H6zm.33 4.75A3.25 3.25 0 0 0 3.1 8.641L2.838 11h10.324L12.9 8.641A3.25 3.25 0 0 0 9.67 5.75zM15 13.5V15H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$ef90945cc818a91e$var$LobbyBellIcon.displayName = 'LobbyBellIcon';
var $ef90945cc818a91e$var$_default = module.exports.default = $ef90945cc818a91e$var$LobbyBellIcon;

});

parcelRegister("9Cyyz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $701277dc6e7898a3$var$_react = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $701277dc6e7898a3$var$_baseNew = $701277dc6e7898a3$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $701277dc6e7898a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $701277dc6e7898a3$var$AutomationIcon = (props)=>/*#__PURE__*/ $701277dc6e7898a3$var$_react.default.createElement($701277dc6e7898a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$701277dc6e7898a3$var$AutomationIcon.displayName = 'AutomationIcon';
var $701277dc6e7898a3$var$_default = module.exports.default = $701277dc6e7898a3$var$AutomationIcon;

});

parcelRegister("efg6m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c939fd7642839817f37f5fef435fb296>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a5eef4da1ee45f40$var$_react = $a5eef4da1ee45f40$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $a5eef4da1ee45f40$var$_baseNew = $a5eef4da1ee45f40$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $a5eef4da1ee45f40$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Changes".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for changes in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a5eef4da1ee45f40$var$ChangesIcon = (props)=>/*#__PURE__*/ $a5eef4da1ee45f40$var$_react.default.createElement($a5eef4da1ee45f40$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M14.78 4.22 11.53.97l-1.06 1.06L12.44 4H2v1.5h10.44l-1.97 1.97 1.06 1.06 3.25-3.25a.75.75 0 0 0 0-1.06M3.56 10.5l1.97-1.97-1.06-1.06-3.25 3.25a.75.75 0 0 0 0 1.06l3.25 3.25 1.06-1.06L3.56 12H14v-1.5z" clip-rule="evenodd"/>`
    }, props));
$a5eef4da1ee45f40$var$ChangesIcon.displayName = 'ChangesIcon';
var $a5eef4da1ee45f40$var$_default = module.exports.default = $a5eef4da1ee45f40$var$ChangesIcon;

});

parcelRegister("FI4AH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2fb18bc89cea9c558386c877fcbee03e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07d604706fb56cdd$var$_react = $07d604706fb56cdd$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $07d604706fb56cdd$var$_baseNew = $07d604706fb56cdd$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $07d604706fb56cdd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartTrendUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Upward trending data; Trend charts; Reports in Jira; Sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07d604706fb56cdd$var$ChartTrendUpIcon = (props)=>/*#__PURE__*/ $07d604706fb56cdd$var$_react.default.createElement($07d604706fb56cdd$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M15 7.5h-1.5V5.56L9.78 9.28a.75.75 0 0 1-1.06 0L7.25 7.81l-2.22 2.22-1.06-1.06 2.75-2.75.056-.052a.75.75 0 0 1 1.004.052l1.47 1.47 3.19-3.19H10.5V3h3.75a.75.75 0 0 1 .75.75z"/>`
    }, props));
$07d604706fb56cdd$var$ChartTrendUpIcon.displayName = 'ChartTrendUpIcon';
var $07d604706fb56cdd$var$_default = module.exports.default = $07d604706fb56cdd$var$ChartTrendUpIcon;

});

parcelRegister("bf5rK", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aff4cd926156d74fe58acdf2d87dd6f1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $82f551fa44ba4d63$var$_react = $82f551fa44ba4d63$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $82f551fa44ba4d63$var$_baseNew = $82f551fa44ba4d63$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $82f551fa44ba4d63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Pages".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for multipe pages in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $82f551fa44ba4d63$var$PagesIcon = (props)=>/*#__PURE__*/ $82f551fa44ba4d63$var$_react.default.createElement($82f551fa44ba4d63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zM4 4h6v1.5H4zm10.5 8.75V6H16v6.75A3.25 3.25 0 0 1 12.75 16H6v-1.5h6.75a1.75 1.75 0 0 0 1.75-1.75M4 7h4.5v1.5H4z" clip-rule="evenodd"/>`
    }, props));
$82f551fa44ba4d63$var$PagesIcon.displayName = 'PagesIcon';
var $82f551fa44ba4d63$var$_default = module.exports.default = $82f551fa44ba4d63$var$PagesIcon;

});

parcelRegister("ggVkr", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd8a9c39c889598d$var$_react = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $bd8a9c39c889598d$var$_baseNew = $bd8a9c39c889598d$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $bd8a9c39c889598d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd8a9c39c889598d$var$PersonAddIcon = (props)=>/*#__PURE__*/ $bd8a9c39c889598d$var$_react.default.createElement($bd8a9c39c889598d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$bd8a9c39c889598d$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $bd8a9c39c889598d$var$_default = module.exports.default = $bd8a9c39c889598d$var$PersonAddIcon;

});

parcelRegister("35vmV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3a8c88470e968ec08c5aa075e8f42b3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $23fa2be7417a36cb$var$_react = $23fa2be7417a36cb$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $23fa2be7417a36cb$var$_baseNew = $23fa2be7417a36cb$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $23fa2be7417a36cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChartBubble".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: Bubble and matrix charts; Matrix view in in JPD
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $23fa2be7417a36cb$var$ChartBubbleIcon = (props)=>/*#__PURE__*/ $23fa2be7417a36cb$var$_react.default.createElement($23fa2be7417a36cb$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M1 13V1h1.5v12a.5.5 0 0 0 .5.5h12V15H3a2 2 0 0 1-2-2"/><path fill="currentcolor" d="M11.27 9.01a1.38 1.38 0 1 1-1.51 1.51l-.01-.14.01-.14A1.38 1.38 0 0 1 11.13 9zM5.75 6.5a1.75 1.75 0 1 1 0 3.5 1.75 1.75 0 0 1 0-3.5m4.75-5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5"/>`
    }, props));
$23fa2be7417a36cb$var$ChartBubbleIcon.displayName = 'ChartBubbleIcon';
var $23fa2be7417a36cb$var$_default = module.exports.default = $23fa2be7417a36cb$var$ChartBubbleIcon;

});

parcelRegister("k2zyM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d288013ed94ec7ddbe1bb143e39a4fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e96f93ff829ead8b$var$_react = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $e96f93ff829ead8b$var$_baseNew = $e96f93ff829ead8b$var$_interopRequireDefault((parcelRequire("jcI35")));
function $e96f93ff829ead8b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "BrowserExtension".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for chrome extensions
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e96f93ff829ead8b$var$BrowserExtensionIcon = (props)=>/*#__PURE__*/ $e96f93ff829ead8b$var$_react.default.createElement($e96f93ff829ead8b$var$_baseNew.default, Object.assign({
        name: "BrowserExtensionIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M9.25 2v.5h2.25a2 2 0 0 1 2 2v2.25h.5a2 2 0 1 1 0 4h-.5V13a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-2.25a.75.75 0 0 1 .75-.75h.5a1.25 1.25 0 1 0 0-2.5h-.5A.75.75 0 0 1 1 6.75V4.5a2 2 0 0 1 2-2h2.25V2a2 2 0 1 1 4 0M2.5 4.5A.5.5 0 0 1 3 4h8.5a.5.5 0 0 1 .5.5V13a.5.5 0 0 1-.5.5H3a.5.5 0 0 1-.5-.5v-1.511a2.75 2.75 0 0 0 0-5.478z" clip-rule="evenodd"/>`
    }, props));
$e96f93ff829ead8b$var$BrowserExtensionIcon.displayName = 'BrowserExtensionIcon';
var $e96f93ff829ead8b$var$_default = module.exports.default = $e96f93ff829ead8b$var$BrowserExtensionIcon;

});

parcelRegister("7JEHy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::62b2367dcefa534d3cc5e1a7e205b220>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a1c4ed3f3b8d061$var$_react = $5a1c4ed3f3b8d061$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $5a1c4ed3f3b8d061$var$_baseNew = $5a1c4ed3f3b8d061$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $5a1c4ed3f3b8d061$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Goal".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for goals in Atlas.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5a1c4ed3f3b8d061$var$GoalIcon = (props)=>/*#__PURE__*/ $5a1c4ed3f3b8d061$var$_react.default.createElement($5a1c4ed3f3b8d061$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m8-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M4 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0" clip-rule="evenodd"/>`
    }, props));
$5a1c4ed3f3b8d061$var$GoalIcon.displayName = 'GoalIcon';
var $5a1c4ed3f3b8d061$var$_default = module.exports.default = $5a1c4ed3f3b8d061$var$GoalIcon;

});

parcelRegister("8BlKa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6b7be9690353c7bf82b96c9a0cc89ae3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6432a540254daa54$var$_react = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $6432a540254daa54$var$_baseNew = $6432a540254daa54$var$_interopRequireDefault((parcelRequire("jcI35")));
function $6432a540254daa54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "RoadmapsPlan".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for representing plans.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6432a540254daa54$var$RoadmapsPlanIcon = (props)=>/*#__PURE__*/ $6432a540254daa54$var$_react.default.createElement($6432a540254daa54$var$_baseNew.default, Object.assign({
        name: "RoadmapsPlanIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.5 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2M1 3.5a2.5 2.5 0 0 1 4.886-.75h4.864a3 3 0 1 1 0 6h-5.5a1.5 1.5 0 1 0 0 3h4.865a2.501 2.501 0 1 1 0 1.5H5.25a3 3 0 1 1 0-6h5.5a1.5 1.5 0 0 0 0-3H5.886A2.501 2.501 0 0 1 1 3.5m11.5 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$6432a540254daa54$var$RoadmapsPlanIcon.displayName = 'RoadmapsPlanIcon';
var $6432a540254daa54$var$_default = module.exports.default = $6432a540254daa54$var$RoadmapsPlanIcon;

});

parcelRegister("bOuCy", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ab25c6896d727bd4806885f3b789ade9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $899c1ddf7bade55b$var$_react = $899c1ddf7bade55b$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $899c1ddf7bade55b$var$_baseNew = $899c1ddf7bade55b$var$_interopRequireDefault((parcelRequire("f9BpS")));
function $899c1ddf7bade55b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Bug".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: Request types in JSM, bugs in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $899c1ddf7bade55b$var$BugIcon = (props)=>/*#__PURE__*/ $899c1ddf7bade55b$var$_react.default.createElement($899c1ddf7bade55b$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 2.5A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 8 2.5m3 1.52V4a3 3 0 0 0-6 0v.02c-.29.05-.553.182-.761.372l-.887-.633-.917-2.064-1.37.61.944 2.125c.09.204.234.38.416.51l1.325.946V7H.5v1.5h3.25v1.149l-1.15.958a1.25 1.25 0 0 0-.318.401L1.08 13.415l1.342.67 1.18-2.36.46-.383A4.25 4.25 0 0 0 8.001 14h.249A4 4 0 0 0 12 11.393l.4.333 1.18 2.36 1.34-.671-1.202-2.407a1.25 1.25 0 0 0-.318-.401l-1.15-.958V8.5h3.25V7h-3.25V5.886l1.325-.946a1.25 1.25 0 0 0 .416-.51l.944-2.125-1.37-.61-.917 2.064-.887.633A1.5 1.5 0 0 0 11 4.02M10.75 10V5.5h-5.5v4.443l.035.226A2.75 2.75 0 0 0 8 12.5h.249a2.5 2.5 0 0 0 2.5-2.5" clip-rule="evenodd"/>`
    }, props));
$899c1ddf7bade55b$var$BugIcon.displayName = 'BugIcon';
var $899c1ddf7bade55b$var$_default = module.exports.default = $899c1ddf7bade55b$var$BugIcon;

});

parcelRegister("2GO8b", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0b5a64a2ca9b8ddc91e264b2e4d54e26>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1f5663fd08175dde$var$_react = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $1f5663fd08175dde$var$_baseNew = $1f5663fd08175dde$var$_interopRequireDefault((parcelRequire("jcI35")));
function $1f5663fd08175dde$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Notepad".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Whiteboard component 'card'
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1f5663fd08175dde$var$NotepadIcon = (props)=>/*#__PURE__*/ $1f5663fd08175dde$var$_react.default.createElement($1f5663fd08175dde$var$_baseNew.default, Object.assign({
        name: "NotepadIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4 1V0h1.5v1h1.75V0h1.5v1h1.75V0H12v1h1a2 2 0 0 1 2 2v7.75c0 .52-.206 1.017-.573 1.384l-3.293 3.293A1.96 1.96 0 0 1 9.75 16H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2zm0 1.5H3a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h6v-3.75a.75.75 0 0 1 .75-.75h3.75V3a.5.5 0 0 0-.5-.5h-1v2h-1.5v-2H8.75v2h-1.5v-2H5.5v2H4zm8.94 9H10.5v2.44zM12 8H4V6.5h8zm-5 2v1.5H4V10z" clip-rule="evenodd"/>`
    }, props));
$1f5663fd08175dde$var$NotepadIcon.displayName = 'NotepadIcon';
var $1f5663fd08175dde$var$_default = module.exports.default = $1f5663fd08175dde$var$NotepadIcon;

});

parcelRegister("6xXDI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::840e9064aa0761adacec2a7ce2dee628>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4c441650e47ff0d3$var$_react = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("1oC0p")));

var $4c441650e47ff0d3$var$_baseNew = $4c441650e47ff0d3$var$_interopRequireDefault((parcelRequire("jcI35")));
function $4c441650e47ff0d3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sync".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for syncing changes and save operations.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4c441650e47ff0d3$var$SyncIcon = (props)=>/*#__PURE__*/ $4c441650e47ff0d3$var$_react.default.createElement($4c441650e47ff0d3$var$_baseNew.default, Object.assign({
        name: "SyncIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 .5h4.25a.75.75 0 0 1 .75.75V5.5H5.5V2.941a9 9 0 0 0-1.094.916C3.42 4.83 2.5 6.214 2.5 8c0 1.813.817 3.18 1.871 4.11 1.079.95 2.346 1.39 3.129 1.39V15c-1.217 0-2.825-.623-4.121-1.765C2.058 12.07 1 10.312 1 8c0-2.339 1.21-4.084 2.354-5.211.308-.304.615-.567.9-.789H2zm10.621 2.266C13.942 3.93 15 5.688 15 8c0 2.338-1.204 4.079-2.344 5.201-.304.3-.607.56-.889.78H14v1.5H9.75a.75.75 0 0 1-.75-.75v-4.25h1.5v2.573a9 9 0 0 0 1.104-.921C12.584 11.166 13.5 9.787 13.5 8c0-1.813-.817-3.18-1.871-4.11C10.551 2.94 9.283 2.5 8.5 2.5V1c1.217 0 2.825.623 4.121 1.766" clip-rule="evenodd"/>`
    }, props));
$4c441650e47ff0d3$var$SyncIcon.displayName = 'SyncIcon';
var $4c441650e47ff0d3$var$_default = module.exports.default = $4c441650e47ff0d3$var$SyncIcon;

});


//# sourceMappingURL=home.8e9d7be4.js.map
